{
  "imageUpload": {
    "preparing": "A preparar a imagem…",
    "uploading": "A enviar a imagem…",
    "retrying": "A tentar novamente o envio…",
    "failed": "Não foi possível enviar a imagem",
    "failedTooLarge": "A imagem é demasiado grande",
    "failedUnsupported": "Formato de imagem não suportado",
    "failedNetwork": "Sem ligação ao servidor",
    "failedPrepare": "Não foi possível processar a imagem",
    "retry": "Tentar novamente",
    "pendingWarning": "{{count}} imagem(ns) só existem neste navegador e não foram guardadas no servidor. Perder-se-ão se fechar ou recarregar a página."
  },
  "super": {
    "title": "Administração",
    "issuesTitle": "Relatos e ideias",
    "issuesSubtitle": "Reveja as incidências e sugestões enviadas pelos utilizadores",
    "brandsTab": "Marcas",
    "brandsTitle": "Marcas e distribuidores",
    "brandsSubtitle": "Quem nos traz cada cliente e o que vê ao entrar"
  },
  "radiologyStyle": {
    "title": "O seu estilo radiológico",
    "description": "Crie uma lista com as suas preferências sobre como gosta de redigir os seus relatórios. Por exemplo: «Quero que todos os achados estejam em negrito».",
    "menuLabel": "O seu estilo radiológico",
    "settingsTitle": "O seu estilo radiológico",
    "settingsDescription": "Defina como gosta de redigir os seus relatórios com uma lista de preferências pessoais",
    "settingsText": "Crie e edite a sua lista de preferências de estilo. Por exemplo: «Quero que todos os achados estejam em negrito».",
    "settingsButton": "Editar o meu estilo",
    "empty": "Ainda não adicionou nenhuma preferência de estilo.",
    "placeholder": "Ex: Quero que todos os achados estejam em negrito",
    "addRule": "Adicionar preferência",
    "removeRule": "Remover preferência",
    "saving": "A guardar…",
    "saved": "O seu estilo radiológico foi guardado com sucesso",
    "saveError": "Não foi possível guardar o seu estilo radiológico",
    "limitHint": "Até {{maxRules}} preferências de {{maxLength}} caracteres cada.",
    "maxRulesReached": "Atingiu o máximo de {{maxRules}} preferências",
    "ruleTooLong": "Uma preferência excede {{maxLength}} caracteres: reduza-a para guardar"
  },
  "common": {
    "welcome": "Bem-vindo",
    "unknownModality": "Modalidade desconhecida",
    "unknownRegion": "Região desconhecida",
    "professionalTitleDefault": "Dr.",
    "login": "Entrar",
    "logout": "Sair",
    "save": "Guardar",
    "cancel": "Cancelar",
    "delete": "Eliminar",
    "edit": "Editar",
    "view": "Ver",
    "close": "Fechar",
    "search": "Pesquisar",
    "loading": "A carregar...",
    "sending": "A enviar...",
    "error": "Erro",
    "success": "Sucesso",
    "email": "E-mail",
    "password": "Palavra-passe",
    "submit": "Enviar",
    "back": "Voltar",
    "continue": "Continuar",
    "next": "Próximo",
    "previous": "Anterior",
    "confirm": "Confirmar",
    "yes": "Sim",
    "no": "Não",
    "goHome": "Ir para o início",
    "home": "Início",
    "myInsights": "As minhas estatísticas",
    "groupReports": "Histórico de trabalho",
    "createReport": "Criar relatório",
    "templates": "Modelos",
    "accounts": "Contas",
    "users": "Utilizadores",
    "issues": "Problemas",
    "adminPanel": "Painel admin",
    "orgAdmin": "Organização",
    "configuration": "Configurações",
    "parameters": "Parâmetros",
    "openMenu": "Abrir menu",
    "collapseMenu": "Recolher menu",
    "expandMenu": "Expandir menu",
    "writeHere": "Escreva aqui...",
    "headingPlaceholder": "Título",
    "selectButtonsToExport": "Selecionar botões para exportar",
    "exportSelection": "Exportar seleção",
    "configureButtons": "Configurar botões para exportar",
    "searchPlaceholder": "Procurar...",
    "clearSelection": "Limpar seleção",
    "noResults": "Nenhum resultado encontrado",
    "commands": "Comandos",
    "insert": "Inserir",
    "update": "Atualizar",
    "generate": "Gerar",
    "select": "Selecionar",
    "dictate": "Ditar",
    "language": "Idioma",
    "showing": "Mostrando",
    "of": "de",
    "or": "ou",
    "page": "Página",
    "item": "item",
    "items": "itens",
    "copy": "Copiar",
    "clear": "Limpar",
    "share": "Compartilhar",
    "discard": "Descartar",
    "deleting": "A eliminar...",
    "enabled": "Ativado",
    "disabled": "Desativado",
    "send": "Enviar",
    "pause": "Pausar",
    "resume": "Retomar",
    "showLaterality": "Mostrar lateralidade",
    "hideLaterality": "Ocultar lateralidade",
    "laterality": {
      "left": "Esquerda",
      "right": "Direita",
      "both": "Bilateral"
    },
    "groups": "Grupos"
  },
  "commandPalette": {
    "searchPlaceholder": "Digite um comando...",
    "results": "Resultados",
    "searching": "A pesquisar...",
    "noTemplatesFound": "Nenhum modelo encontrado",
    "suggestions": "Sugestões",
    "createTemplate": "Criar modelo",
    "startDictation": "Iniciar ditado",
    "generateReport": "Gerar relatório",
    "recentTemplates": "Modelos recentes",
    "errorLoadingTemplates": "Erro ao carregar modelos",
    "errorSearching": "Erro ao pesquisar modelos",
    "mustUseWithinProvider": "useCommandPalette deve ser usado dentro de CommandPaletteProvider"
  },
  "auth": {
    "welcomeHello": "Olá,",
    "welcomeBack": "Bem-vindo",
    "launchSignInNeeded": "O seu exame está à espera. Inicie sessão para continuar.",
    "launchIdentityRefused": "Não foi possível iniciar sessão automaticamente: os dados da sua conta não correspondem ao grupo a partir do qual o exame foi lançado. Contacte o seu administrador. Entretanto, pode iniciar sessão aqui.",
    "emailLabel": "E-mail",
    "passwordLabel": "Palavra-passe",
    "loginTitle": "Entrar no Ainovis",
    "loginSubtitle": "Digite as suas credenciais para aceder",
    "forgotPassword": "Esqueceu a sua palavra-passe?",
    "rememberMe": "Lembrar-me",
    "noAccount": "Não tem uma conta?",
    "signUp": "Registar-se",
    "alreadyHaveAccount": "Já tem uma conta?",
    "signIn": "Entrar",
    "verifyEmail": "Verificar e-mail",
    "verifyEmailText": "Enviámos um e-mail de verificação para o seu endereço",
    "resetPassword": "Redefinir palavra-passe",
    "resetPasswordText": "Digite a sua nova palavra-passe",
    "newPassword": "Nova palavra-passe",
    "confirmPassword": "Confirmar palavra-passe",
    "sendResetLink": "Enviar link de redefinição",
    "backToLogin": "Voltar ao login",
    "googleLogin": "Continuar com Google",
    "microsoftLogin": "Continuar com Microsoft",
    "orLoginWith": "Ou faça login com",
    "authenticatingMicrosoft": "Autenticando com Microsoft...",
    "processingAuth": "A processar autenticação...",
    "resetPasswordTitle": "Redefinir palavra-passe",
    "resetPasswordDescription": "Digite a sua nova palavra-passe",
    "resetting": "Redefinindo...",
    "resetPasswordButton": "Redefinir palavra-passe",
    "invalidToken": "Token inválido ou expirado",
    "completeAllFields": "Por favor, preencha todos os campos",
    "passwordsDoNotMatch": "As palavras-passe não correspondem",
    "passwordMinLength": "A palavra-passe deve ter pelo menos 6 carateres",
    "passwordResetSuccess": "Palavra-passe redefinida com sucesso",
    "enterButton": "Entrar",
    "emailPlaceholder": "E-mail",
    "passwordPlaceholder": "Palavra-passe",
    "completeCaptcha": "Por favor, complete o captcha",
    "continueWith": "ou continuar com",
    "continueWithMicrosoft": "Continuar com Microsoft",
    "forgotPasswordTitle": "Esqueceu a sua palavra-passe?",
    "forgotPasswordDescription": "Não se preocupe, enviaremos instruções para redefini-la",
    "sendInstructions": "Enviar instruções",
    "emailSentTitle": "E-mail enviado",
    "emailSentMessage": "Enviámos um e-mail para {{email}} com instruções para redefinir a sua palavra-passe",
    "checkSpam": "Se não receber o e-mail em alguns minutos, verifique a sua pasta de spam"
  },
  "notFound": {
    "title": "404",
    "subtitle": "Página não encontrada",
    "message": "Desculpe, a página que procura não existe ou foi movida"
  },
  "dashboard": {
    "title": "Painel de Controle",
    "reports": "Relatórios",
    "recentReports": "Os seus relatórios diagnósticos recentes",
    "createReport": "Criar relatório",
    "viewAll": "Ver todos",
    "statistics": "Estatísticas",
    "totalReports": "Total de relatórios",
    "pendingReports": "Relatórios pendentes",
    "completedReports": "Relatórios concluídos"
  },
  "reports": {
    "deselectAll": "Desmarcar todos",
    "allSelected": "Todos selecionados ({{count}})",
    "tapToSelectAll": "Selecionar todos",
    "selectedCountHint": "· {{count}} selecionados",
    "selectedCountHint_one": "· {{count}} selecionado",
    "selectedCountHint_other": "· {{count}} selecionados",
    "signReport": "Assinar",
    "signedBy": "Assinado por:",
    "licenseNumber": "Nº de inscrição",
    "sendBusy": "Aguarde até que o processo em curso termine",
    "requestEdit": "Solicitar permissão de edição",
    "requestEditSent": "Pedido enviado",
    "requestEditError": "Não foi possível enviar o pedido. Tente novamente.",
    "editRequestToast": "{{name}} solicita permissão de edição.",
    "editRequestManage": "Gerir",
    "editRequestSomeone": "Um utilizador",
    "title": "Relatórios",
    "newReport": "Novo relatório",
    "reportList": "Lista de relatórios",
    "reportDetails": "Detalhes do relatório",
    "status": "Status",
    "createdAt": "Criado em",
    "updatedAt": "Atualizado em",
    "createdBy": "Criado por",
    "draft": "Rascunho",
    "published": "Publicado",
    "archived": "Arquivado",
    "noReports": "Nenhum relatório disponível",
    "deleteConfirm": "Tem certeza de que deseja eliminar este relatório?",
    "studyDescription": "Descrição do estudo",
    "studyDescriptionPlaceholder": "Digite a descrição do estudo...",
    "reasonForRequestedProcedure": "Motivo do pedido",
    "reportGeneration": "Geração",
    "automatic": "Automático",
    "manual": "Manual",
    "automaticTooltip": "Gerar o relatório automaticamente",
    "manualTooltip": "Gerar o relatório a partir do modelo selecionado",
    "reportFormat": "Tipo de relatório",
    "inside": "Inside",
    "first": "First",
    "insideTooltip": "Os achados serão distribuídos uniformemente dentro da seção 'Achados'",
    "firstTooltip": "Os achados serão colocados no início da seção 'Achados'",
    "selectedTemplate": "Modelo Selecionado",
    "templateList": "Lista de Modelos",
    "auto": "Auto",
    "automatic2": "Automático",
    "enterDescription": "Por favor, insira uma descrição do estudo",
    "reportCopied": "Relatório copiado com sucesso",
    "reportGenerated": "Relatório gerado com sucesso",
    "reportSaved": "Relatório guardado com sucesso",
    "noReportToSave": "Nenhum relatório gerado para guardar",
    "missingReportInfo": "Faltam informações do relatório",
    "timeoutError": "A geração demorou muito. Tente com uma descrição mais curta",
    "generateButton": "Gerar relatório",
    "generating": "A gerar...",
    "thinking": "A pensar...",
    "saveButton": "Guardar relatório",
    "saving": "A guardar...",
    "generatingMessage": "A gerar relatório...",
    "savingMessage": "A guardar relatório...",
    "editorPlaceholder": "O relatório gerado aparecerá aqui...",
    "activateDictation": "Ativar ditado por voz",
    "holdMicSendHint": "Solte para enviar · Esc para cancelar",
    "holdMicCancelHint": "Solte para cancelar",
    "keepAllContent": "Manter todo o conteúdo marcado",
    "keepContentDesc": "Manter conteúdo marcado (mesclar sem eliminar)",
    "deleteAllContent": "Eliminar todo o conteúdo marcado",
    "keepOriginal": "Manter texto original",
    "keepOriginalDesc": "Manter o texto original (descartar alterações)",
    "applyUpdates": "Aplicar todas as atualizações",
    "generateReport": "Gerar relatório",
    "basedOnRecentActivity": "Com base em sua atividade recente",
    "aiDisclaimer": "Ainovis pode cometer erros. Considere verificar informações importantes",
    "reportContent": "Parâmetros do relatório",
    "continueWithBaseTemplate": "Continuar com modelo base",
    "blocksDetected": "Blocos detetados",
    "selectBlockHint": "Selecione um bloco ou continue com o modelo base",
    "continueWithNormalTemplate": "Continuar sem blocos",
    "referenceSelected": "Referência selecionada ✓",
    "blockSelected": "Bloco selecionado ✓",
    "blockSkipped": "Continuando sem bloco ✓",
    "description": "Descritivo",
    "detectedProcedures": "Procedimentos detetados",
    "noProceduresDetected": "Nenhum procedimento detetado",
    "detectedLaterality": "Lateralidade detetada",
    "noLateralityFound": "Nenhuma lateralidade encontrada",
    "searchLaterality": "Alinhar lateralidade",
    "lateralityUpdated": "Lateralidade atualizada",
    "errorSearchingLaterality": "Erro ao detetar lateralidade",
    "findingsFirst": "Achados no início",
    "findingsInside": "Achados dentro do texto",
    "welcome": "Bem-vindo {{title}} {{surname}}",
    "searchTemplate": "Pesquisar modelo...",
    "loadingTemplate": "A carregar modelo...",
    "multipleReferencesDetected": "Múltiplas referências detetadas",
    "selectReferenceHint": "Selecione uma opção para continuar com a geração",
    "generateManualReport": "Gerar relatório manual",
    "blankCanvas": "Ecrã em branco",
    "createTemplate": "Criar modelo",
    "viewPowerBI": "Ver Estatísticas",
    "uploadAudio": "Processar áudio em lotes",
    "activitySummary": "Resumo de atividade",
    "viewMoreStats": "Ver mais estatísticas",
    "noTemplatesFound": "Nenhum modelo encontrado",
    "errorCreatingBlankCanvas": "Erro ao criar ecrã em branco",
    "manualModePlaceholder": "Digite o modelo que deseja utilizar",
    "navigate": "navegar",
    "select": "selecionar",
    "close": "fechar",
    "loadingTemplates": "A carregar modelos...",
    "searchPlaceholder": "Pesquisar relatório...",
    "reportsHistorySidebarTitle": "Histórico de relatórios",
    "reportsHistorySidebarTitleSaved": "Relatórios enviados",
    "reportsHistoryPreviewStamp": "Relatório enviado",
    "reportsHistorySidebarClose": "Fechar painel de histórico",
    "reportsHistoryLoading": "A carregar…",
    "reportsHistoryError": "Não foi possível carregar o histórico",
    "reportsHistoryNoResults": "Sem resultados",
    "reportsHistoryDraftsEmpty": "Não tem rascunhos",
    "reportsHistorySavedEmpty": "Não tem relatórios enviados",
    "reportsHistoryUntitled": "Sem título",
    "reportsHistoryTabDrafts": "Rascunhos",
    "reportsHistoryTabSaved": "Enviados",
    "createReport": "Criar relatório",
    "currentStatus": "Estado atual",
    "pendingReview": "Relatórios pendentes de revisão",
    "savedToday": "Relatórios salvos hoje",
    "draftReports": "Relatórios em rascunho",
    "recentReports": "Relatórios diagnósticos recentes",
    "drafts": "Rascunhos",
    "sent": "Enviados",
    "saved": "Enviados",
    "sharedWithMe": "Partilhados comigo",
    "ownedByMe": "Sou o proprietário",
    "noOwnedDrafts": "Nenhum rascunho de que seja proprietário",
    "countOwned": "{{count}} próprios",
    "workHistoryTitle": "Histórico de trabalho",
    "viewGroupWorkHistory": "Ver histórico de trabalho do grupo",
    "countDrafts": "{{count}} rascunhos",
    "countBatches": "{{count}} lotes",
    "countSent": "{{count}} enviados",
    "countShared": "{{count}} partilhados",
    "diagnosis": "Conclusão",
    "versions": "Versões",
    "version": "versão",
    "lastUpdate": "Última atualização",
    "actions": "Ações",
    "noDrafts": "Não há rascunhos",
    "noSharedDrafts": "Nenhum relatório partilhado consigo",
    "noDiagnosis": "(Sem diagnóstico)",
    "loadingVersions": "A carregar versões...",
    "owner": "Proprietário",
    "modalities": "Modalidades",
    "procedure": "Procedimento",
    "procedures": "Procedimentos",
    "time": "Hora",
    "draftVersionsInfo": "Este rascunho tem {{count}} versão(ões) salva(s)",
    "report": "relatório",
    "reports": "relatórios",
    "yourPerformance": "O seu desempenho",
    "last7Days": "Últimos 7 dias",
    "thisWeek": "Esta semana",
    "thisMonth": "Este mês",
    "today": "Hoje",
    "yesterday": "Ontem",
    "last30Days": "Últimos 30 dias",
    "older": "Anteriores",
    "totalReports": "Total",
    "deleteDraftTitle": "Eliminar rascunho",
    "leaveDraft": "Abandonar rascunho",
    "leaveDraftTitle": "Abandonar rascunho",
    "leaveDraftConfirm": "Abandonar",
    "leaveDraftMessage": "Deixará de ter acesso a este rascunho partilhado. O proprietário poderá voltar a partilhá-lo consigo.",
    "deleteReportTitle": "Eliminar relatório",
    "deleteDraftMessage": "Tem certeza de que deseja eliminar este rascunho e todas as suas versões? Esta ação não pode ser desfeita.",
    "deleteReportMessage": "Tem certeza de que deseja eliminar este relatório guardado? Esta ação não pode ser desfeita.",
    "deleteBatchTitle": "Eliminar lote",
    "deleteBatchMessage": "Tem certeza de que deseja eliminar este lote e todos os seus estudos? Esta ação não pode ser desfeita.",
    "errorLoadingReport": "Erro ao carregar o relatório",
    "noContentToCopy": "Não há conteúdo para copiar",
    "contentCopied": "Conteúdo copiado para a área de transferência",
    "errorCopying": "Erro ao copiar o conteúdo",
    "errorPreSaveValidation": "Erro ao validar antes de guardar",
    "preSaveInconsistencies": "Inconsistências detetadas",
    "preSaveVersions": "Múltiplas versões",
    "preSaveVersionsMsg": "Apenas a versão atual será guardada e as {{count}} restantes serão descartadas.",
    "errorSavingReport": "Erro ao guardar o relatório",
    "errorSavingDraft": "Erro ao guardar o rascunho",
    "draftDeleted": "Rascunho eliminado com sucesso",
    "errorDeletingDraft": "Erro ao eliminar o rascunho",
    "emptyTechnique": "A técnica está vazia",
    "proceduresFound": "Procedimentos atualizados",
    "errorSearchingProcedures": "Erro ao pesquisar procedimentos",
    "blankVersionCreated": "Ecrã em branco criado",
    "errorCreatingBlankVersion": "Erro ao criar ecrã em branco",
    "loadingReport": "A carregar relatório...",
    "deletingMessage": "A eliminar rascunho...",
    "searchingProcedures": "A pesquisar procedimentos...",
    "searchingLaterality": "A detetar lateralidade...",
    "hideProcedures": "Ocultar procedimentos",
    "searchProcedures": "Pesquisar procedimentos",
    "showProcedures": "Mostrar procedimentos",
    "confirmDeleteDraft": "Tem certeza de que deseja eliminar este rascunho? Esta ação não pode ser desfeita.",
    "inconsistency": "Inconsistência",
    "show": "Mostrar",
    "preSaveTitle": "Antes de guardar",
    "preSaveSubtitle": "As seguintes advertências foram detetadas:",
    "confirmSave": "Enviar mesmo assim",
    "unsavedChanges": "Alterações não guardadas",
    "unsavedChangesMessage": "\"{{title}}\" tem alterações não guardadas. Descartar alterações?",
    "maxVersionsReached": "Máximo de relatórios alcançado",
    "settings": "Configuração",
    "reportType": "Tipo de relatório",
    "noTemplateSelected": "Detecção automática",
    "useAnotherTemplate": "Usar outro modelo",
    "change": "Alterar",
    "changeTemplate": "Alterar modelo",
    "backToAutoDetection": "Voltar à detecção automática",
    "autoDetection": "Detecção automática",
    "noDescription": "Sem descrição",
    "resume": "Retomar",
    "pause": "Pausar",
    "process": "Processar",
    "processingAudio": "A processar áudio...",
    "analyzingVoice": "A analisar a sua voz...",
    "transcribingAudio": "A transcrever áudio...",
    "interpretingCommands": "A interpretar comandos...",
    "preparingResult": "A preparar resultado...",
    "analyzingText": "A analisar o seu texto...",
    "understandingIntent": "A compreender a intenção...",
    "readingContext": "A ler o contexto...",
    "identifyingSections": "A identificar secções...",
    "writing": "A escrever...",
    "fillingReport": "A preencher o relatório...",
    "writingSections": "A redigir secções...",
    "addingFindings": "A adicionar achados...",
    "refiningContent": "A refinar o conteúdo...",
    "applyingClassifications": "A aplicar classificações...",
    "evaluatingCriteria": "A avaliar critérios...",
    "calculatingResults": "A calcular resultados...",
    "finalizingReport": "A finalizar...",
    "aiAssistantPlaceholder": "Escreve um texto ou dita com o microfone...",
    "sendToDescriptive": "Para o descritivo",
    "aiChatEmpty": "Envia uma mensagem para começar a conversa",
    "carolinaAssistance": "Carolina Assistance",
    "send": "Enviar",
    "record": "Gravar",
    "generate": "Gerar",
    "selectReference": "Selecione uma das referências para continuar",
    "errorGenerating": "Erro ao gerar o relatório",
    "noTemplateDetected": "Nenhum modelo detetado",
    "reportGeneratedWithReference": "Relatório gerado com a referência selecionada",
    "versionCreated": "Nova versão criada com sucesso",
    "errorCreatingVersion": "Erro ao criar a versão",
    "emptyRecording": "A gravação está vazia",
    "invalidServerResponse": "Erro: resposta do servidor inválida",
    "noAudioDetected": "Nenhum áudio detetado",
    "commandExecuted": "Comando executado com sucesso",
    "audioTranscribed": "Áudio transcrito com sucesso",
    "audioProcessingError": "Erro ao processar o áudio",
    "microphoneAccessError": "Não foi possível aceder ao microfone",
    "descriptionRequired": "Deve escrever uma descrição",
    "errorLoadingTemplates": "Não foi possível carregar os modelos",
    "patient": "Paciente",
    "patientId": "ID Paciente",
    "patientIdPlaceholder": "ID...",
    "patientAge": "Idade",
    "patientAgePlaceholder": "Anos",
    "patientSex": "Sexo",
    "patientSexPlaceholder": "Selecionar...",
    "sexMale": "Masculino",
    "sexFemale": "Feminino",
    "studyDate": "Data do estudo",
    "requestReason": "Motivo do pedido",
    "patientNamePlaceholder": "Sobrenome, Nome",
    "requestReasonPlaceholder": "Descrição do motivo...",
    "cancel": "Cancelar",
    "cancelEditing": "Cancelar edição",
    "patientNameRequired": "O nome do paciente é obrigatório",
    "confirmHint": "Enter para confirmar · Esc para cancelar",
    "editPatient": "Editar paciente",
    "deletePatient": "Eliminar paciente",
    "contractReason": "Recolher motivo",
    "expandReason": "Expandir motivo",
    "years": "Anos",
    "modality": "Modalidade",
    "accessionNumber": "Nº Acesso",
    "referringPhysician": "Médico solicitante",
    "previousStudiesTitle": "Estudos Anteriores",
    "previousStudiesHint": "Consulte e compare com estudos anteriores do paciente",
    "allProcedures": "Todos os procedimentos",
    "study": "estudo",
    "studiesCount": "estudos",
    "studyPlural": "estudos",
    "batches": "Lotes",
    "batchStudies": "Estudos",
    "noBatches": "Nenhum lote pendente",
    "continueBatch": "Continuar",
    "noStudiesFound": "Nenhum estudo anterior encontrado",
    "studyStatus_completed": "Concluído",
    "studyStatus_pending": "Pendente",
    "studyStatus_cancelled": "Cancelado",
    "loadPrevStudies": "Carregar estudos anteriores",
    "reportClinicalInfo": "Informação clínica",
    "reportTechnique": "Técnica",
    "reportFindings": "Achados",
    "reportConclusion": "Conclusão",
    "conclusionType": "Conclusão",
    "conclusionBrief": "Conclusão breve",
    "conclusionNormal": "Conclusão normal",
    "conclusionExtensive": "Conclusão extensa",
    "conclusionBriefShort": "Breve",
    "conclusionNormalShort": "Normal",
    "conclusionExtensiveShort": "Extensa",
    "speedMode": "Modo de velocidade",
    "fast": "Rápido",
    "accurate": "Preciso",
    "fastModeDesc": "Geração rápida",
    "accurateModeDesc": "Maior precisão",
    "loadTemplate": "Carregar relatório sem alterações",
    "templateNotes": "Deseja modificar algo ao gerar o novo relatório?",
    "templateNotesPlaceholder": "Ex.: Alterar achados no fígado, adicionar nódulo pulmonar de 8mm…",
    "needDescriptive": "Escreva algo no campo de texto para poder gerar",
    "useAsTemplate": "Gerar usando isto como modelo",
    "noReportContent": "Nenhum conteúdo de relatório disponível",
    "searchStudies": "Pesquisar por procedimento ou data…",
    "previousStudy": "Estudo anterior",
    "makeChanges": "Realizar alterações",
    "makeChangesPlaceholder": "Descreva as alterações que deseja realizar no relatório comparativo…",
    "classificationSectionsEmpty": "As seções de técnica, achados e conclusão devem estar completas para classificar",
    "classificationSuccess": "Classificação realizada com sucesso",
    "classificationError": "Erro ao realizar a classificação",
    "editorNotReady": "O editor não está pronto",
    "classificationUnchanged": "O conteúdo do relatório não mudou desde a última classificação.",
    "classificationNoFindings": "Não foram encontrados achados compatíveis para esta classificação",
    "classificationInResearch": "Esta funcionalidade está em fase de investigação. Se desejar utilizá-la, solicite-a ao seu administrador.",
    "classifications": "Classificações",
    "classificationsTitle": "Classificações",
    "fleischnerClassification": "Classificação de Fleischner",
    "fleischnerDesc": "Nódulos pulmonares incidentais — Fleischner 2017",
    "analyzing": "Analisando…",
    "classify": "Classificar",
    "results": "Resultados",
    "table": "Tabela",
    "fleischnerCriteria": "Critérios de Fleischner",
    "fleischner_toggleHighlight": "Mostrar/ocultar destaque",
    "fleischnerDescription": "Diretrizes de acompanhamento para nódulos pulmonares incidentais detectados por TC, segundo tamanho, número e tipo de nódulo.",
    "singleSolidNodule": "Nódulo sólido único",
    "multipleSolidNodules": "Múltiplos nódulos sólidos",
    "subsolidNodules": "Nódulos subsólidos",
    "pureGroundGlass": "Vidro fosco puro",
    "partSolidNodule": "Nódulo parcialmente sólido",
    "size": "Tamanho",
    "lowRisk": "Baixo risco",
    "highRisk": "Alto risco",
    "followUp": "Acompanhamento",
    "noFollowUp": "Sem acompanhamento",
    "partSolidNote": "Se a parte sólida ≥ 6 mm, considerar PET-TC ou ressecção.",
    "reference": "Referência: MacMahon H et al.",
    "singleLt6LowRisk": "Sem acompanhamento",
    "singleLt6HighRisk": "TC aos 12 meses (opcional)",
    "single6to8LowRisk": "TC aos 6–12 meses → considerar aos 18–24 meses",
    "single6to8HighRisk": "TC aos 6–12 meses → repetir aos 18–24 meses",
    "singleGt8LowRisk": "Considerar TC aos 3 meses, PET-TC ou biópsia",
    "singleGt8HighRisk": "Igual ao baixo risco",
    "multipleLt6LowRisk": "Sem acompanhamento",
    "multipleLt6HighRisk": "TC aos 12 meses",
    "multipleGte6LowRisk": "TC aos 3–6 meses → considerar aos 18–24 meses",
    "multipleGte6HighRisk": "TC aos 3–6 meses → repetir aos 18–24 meses",
    "ggLt6": "Sem acompanhamento",
    "ggGte6": "TC aos 6–12 meses → depois a cada 2 anos até 5 anos",
    "psLt6": "Sem acompanhamento",
    "psGte6": "TC aos 3–6 meses → se persistir, acompanhamento anual por 5 anos",
    "conclusionNoFollowUp": "Não requer acompanhamento segundo critérios de Fleischner 2017.",
    "conclusionOptionalCT12": "Recomenda-se controle opcional com TC aos 12 meses segundo critérios de Fleischner 2017.",
    "conclusionCT6to12Consider18to24": "Recomenda-se controle com TC aos 6-12 meses, considerando acompanhamento adicional aos 18-24 meses segundo critérios de Fleischner 2017.",
    "conclusionCT6to12Repeat18to24": "Recomenda-se controle com TC aos 6-12 meses, com acompanhamento adicional aos 18-24 meses segundo critérios de Fleischner 2017.",
    "conclusionConsiderCT3PetBiopsy": "Recomenda-se considerar TC aos 3 meses, PET-TC ou biópsia segundo critérios de Fleischner 2017.",
    "conclusionCT12": "Recomenda-se controle com TC aos 12 meses segundo critérios de Fleischner 2017.",
    "conclusionCT3to6Consider18to24": "Recomenda-se controle com TC aos 3-6 meses, considerando acompanhamento adicional aos 18-24 meses segundo critérios de Fleischner 2017.",
    "conclusionCT3to6Repeat18to24": "Recomenda-se controle com TC aos 3-6 meses, com acompanhamento adicional aos 18-24 meses segundo critérios de Fleischner 2017.",
    "conclusionCT6to12Every2y5y": "Recomenda-se controle com TC aos 6-12 meses, seguido de controles a cada 2 anos até completar 5 anos segundo critérios de Fleischner 2017.",
    "conclusionCT3to6Annual5y": "Recomenda-se controle com TC aos 3-6 meses e, se persistir, acompanhamento anual durante 5 anos segundo critérios de Fleischner 2017.",
    "tirads_classification": "Classificação TI-RADS",
    "tirads_desc": "Nódulos tireoidianos — ACR TI-RADS 2017",
    "tirads_criteria": "Critérios ACR TI-RADS",
    "tirads_description": "Sistema de pontuação para nódulos tireoidianos detectados por ultrassonografia, baseado em composição, ecogenicidade, forma, margens e focos ecogênicos.",
    "tirads_composition": "Composição",
    "tirads_echogenicity": "Ecogenicidade",
    "tirads_shape": "Forma",
    "tirads_margin": "Margens",
    "tirads_echogenicFoci": "Focos Ecogênicos",
    "tirads_feature": "Característica",
    "tirads_points": "Pontos",
    "tirads_compositionCystic": "Cístico ou quase completamente cístico",
    "tirads_compositionSpongiform": "Espongiforme",
    "tirads_compositionMixed": "Misto cístico e sólido",
    "tirads_compositionSolid": "Sólido ou quase completamente sólido",
    "tirads_echogenicityAnechoic": "Anecoico",
    "tirads_echogenicityHyperIso": "Hiperecogênico ou isoecoico",
    "tirads_echogenicityHypo": "Hipoecoico",
    "tirads_echogenicityVeryHypo": "Muito hipoecoico",
    "tirads_shapeWider": "Mais largo que alto",
    "tirads_shapeTaller": "Mais alto que largo",
    "tirads_marginSmooth": "Liso",
    "tirads_marginIllDefined": "Mal definido",
    "tirads_marginLobulated": "Lobulado ou irregular",
    "tirads_marginExtrathyroidal": "Extensão extratireoidiana",
    "tirads_fociNone": "Nenhum ou artefatos de cauda de cometa grandes",
    "tirads_fociMacro": "Macrocalcificações",
    "tirads_fociPeripheral": "Calcificações periféricas (em anel)",
    "tirads_fociPunctate": "Focos ecogênicos punctiformes",
    "tirads_categoriesTitle": "Categorias e recomendações",
    "tirads_categoryCol": "Categoria",
    "tirads_fnaThreshold": "PAAF se",
    "tirads_followUpThreshold": "Acompanhamento se",
    "tirads_tr1_name": "TR1 — Benigno",
    "tirads_tr2_name": "TR2 — Não suspeito",
    "tirads_tr3_name": "TR3 — Levemente suspeito",
    "tirads_tr4_name": "TR4 — Moderadamente suspeito",
    "tirads_tr5_name": "TR5 — Altamente suspeito",
    "tirads_scoringNote": "Somar os pontos de cada categoria (valor mais alto de cada uma). Aplica-se apenas a nódulos ≥ 1 cm ou com características suspeitas.",
    "tirads_reference": "Referência: Tessler FN et al.",
    "tirads_conclusionTR1": "Nódulo tireoidiano classificado como TI-RADS 1 (benigno). Não requer PAAF nem acompanhamento segundo ACR TI-RADS 2017.",
    "tirads_conclusionTR2": "Nódulo tireoidiano classificado como TI-RADS 2 (não suspeito). Não requer PAAF nem acompanhamento segundo ACR TI-RADS 2017.",
    "tirads_conclusionTR3": "Nódulo tireoidiano classificado como TI-RADS 3 (levemente suspeito). Recomenda-se PAAF se ≥ 2.5 cm ou acompanhamento se ≥ 1.5 cm segundo ACR TI-RADS 2017.",
    "tirads_conclusionTR4": "Nódulo tireoidiano classificado como TI-RADS 4 (moderadamente suspeito). Recomenda-se PAAF se ≥ 1.5 cm ou acompanhamento se ≥ 1 cm segundo ACR TI-RADS 2017.",
    "tirads_conclusionTR5": "Nódulo tireoidiano classificado como TI-RADS 5 (altamente suspeito). Recomenda-se PAAF se ≥ 1 cm ou acompanhamento se ≥ 0.5 cm segundo ACR TI-RADS 2017.",
    "tirads_chooseOne": "Escolher 1",
    "tirads_chooseAll": "Todos os que se aplicam",
    "tirads_sumPoints": "Somar pontos de todas as categorias",
    "tirads_selectOptions": "Selecione opções",
    "tirads_recommendationCol": "Recomendação",
    "tirads_noFnaNoFollowUp": "Sem PAAF · Sem acompanhamento",
    "tirads_tr1_label": "Benigno",
    "tirads_tr2_label": "Não suspeito",
    "tirads_tr3_label": "Levemente suspeito",
    "tirads_tr4_label": "Moderadamente suspeito",
    "tirads_tr5_label": "Altamente suspeito",
    "bosniak_classification": "Classificação Bosniak 2019",
    "bosniak_desc": "Massas renais císticas — Bosniak 2019",
    "bosniak_criteria": "Critérios Bosniak 2019",
    "bosniak_description": "Sistema de classificação para massas renais císticas baseado em características de parede, septos, realce, calcificação, nodularidade e atenuação por TC/RM.",
    "bosniak_wall": "Parede",
    "bosniak_septa": "Septos",
    "bosniak_enhancement": "Realce",
    "bosniak_calcification": "Calcificação",
    "bosniak_attenuation": "Atenuação / Sinal",
    "bosniak_chooseOne": "Escolher 1",
    "bosniak_highestCategory": "A categoria mais alta determina a classificação",
    "bosniak_selectFeatures": "Selecione características",
    "bosniak_malignancyRisk": "Risco de malignidade",
    "bosniak_wallThinSmooth": "Parede fina (≤ 2 mm) lisa",
    "bosniak_wallThinSmoothWithSepta": "Parede fina (≤ 2 mm) lisa (com septos ou calcificação)",
    "bosniak_wallMinimalThickening3mm": "Espessamento mínimo liso (3 mm) com realce",
    "bosniak_wallThickOrIrregular": "Parede espessa (≥ 4 mm) ou irregular com realce",
    "bosniak_wallWithNodule": "Parede com nódulo(s) com realce",
    "bosniak_septaNone": "Sem septos",
    "bosniak_septaFewThin": "Poucos (1–3) septos finos (≤ 2 mm) com realce",
    "bosniak_septaMinimalThickeningOrMany": "Espessamento mínimo (3 mm) dos septos ou ≥ 4 septos finos",
    "bosniak_septaThickOrIrregular": "Septos espessos (≥ 4 mm) ou irregulares com realce",
    "bosniak_septaWithNodule": "Septos com nódulo(s) (≥ 4 mm obtuso ou qualquer ângulo agudo)",
    "bosniak_enhanceWallOnly": "A parede pode realizar; sem realce interno",
    "bosniak_enhanceSeptaWall": "Septos e parede podem realizar",
    "bosniak_enhanceSmoothMinimal": "Realce liso de parede ou septos (3 mm)",
    "bosniak_enhanceThickIrregular": "Realce de parede ou septos espessos/irregulares",
    "bosniak_enhanceNodular": "Componente(s) nodular(es) com realce",
    "bosniak_calcNone": "Sem calcificação",
    "bosniak_calcAnyType": "Calcificação de qualquer tipo (parede fina, poucos septos)",
    "bosniak_attenSimpleFluid": "Líquido simples homogéneo (−9 a 20 UH)",
    "bosniak_attenHyperNonContrast": "Hiperatenuante homogéneo (≥ 70 UH) TC sem contraste",
    "bosniak_attenNonEnhancingGt20": "Homogéneo sem realce > 20 UH (protocolo renal TC)",
    "bosniak_attenPortalVenous2130": "Homogéneo 21–30 UH em fase portal venosa",
    "bosniak_attenTooSmall": "Homogéneo de baixa atenuação, demasiado pequeno para caracterizar",
    "bosniak_attenHeteroT1Hyper": "Heterogéneo em T1 sem contraste com saturação de gordura (hiperintenso)",
    "bosniak_bI_label": "Benigno",
    "bosniak_bII_label": "Minimamente complexo",
    "bosniak_bIIF_label": "Minimamente complexo (seguimento)",
    "bosniak_bIII_label": "Indeterminado",
    "bosniak_bIV_label": "Claramente maligno",
    "bosniak_scoringNote": "A categoria Bosniak final é determinada pela característica de maior grau. Não aplicar em lesões com > 25% de componente sólido, etiologia infecciosa/inflamatória ou vascular.",
    "bosniak_reference": "Referência: Silverman SG et al.",
    "bosniak_conclusionI": "Massa renal cística classificada como Bosniak I (benigna). Não requer seguimento segundo a classificação Bosniak 2019.",
    "bosniak_conclusionII": "Massa renal cística classificada como Bosniak II (minimamente complexa, benigna). Risco de malignidade < 1%. Não requer seguimento segundo a classificação Bosniak 2019.",
    "bosniak_conclusionIIF": "Massa renal cística classificada como Bosniak IIF (minimamente complexa, requer seguimento). Risco de malignidade 5–10%. Recomenda-se seguimento com imagem segundo a classificação Bosniak 2019.",
    "bosniak_conclusionIII": "Massa renal cística classificada como Bosniak III (indeterminada). Risco de malignidade ~50%. Recomenda-se cirurgia ou vigilância ativa segundo contexto clínico e a classificação Bosniak 2019.",
    "bosniak_conclusionIV": "Massa renal cística classificada como Bosniak IV (claramente maligna). Risco de malignidade ~90%. Recomenda-se tratamento cirúrgico segundo a classificação Bosniak 2019.",
    "bosniak_tabScoring": "Calculadora",
    "bosniak_tabCategories": "Categorias",
    "bosniak_tabImaging": "Imagem",
    "bosniak_tabInfo": "Info",
    "bosniak_wallDesc": "Avaliação da espessura, regularidade e presença de nódulos na parede do cisto renal. O espessamento ou irregularidade da parede aumenta a categoria Bosniak.",
    "bosniak_septaDesc": "Avaliação do número, espessura e regularidade dos septos intracísticos. Septos espessos ou com nódulos sugerem maior risco de malignidade.",
    "bosniak_enhancementDesc": "Padrão de realce após administração de contraste intravenoso. O realce verdadeiro (≥ 20 UH) de componentes sólidos é fundamental para diferenciar massas benignas de malignas.",
    "bosniak_calcificationDesc": "A calcificação por si só não altera a categoria Bosniak na versão 2019. É documentada mas não modifica a classificação.",
    "bosniak_attenuationDesc": "Características de atenuação (TC) ou sinal (RM) do conteúdo cístico. Os valores de UH e o padrão de sinal determinam se o cisto é simples ou complexo.",
    "bosniak_typicalFindings": "Achados típicos",
    "bosniak_catI_desc": "Cisto renal simples. Parede fina e imperceptível, conteúdo homogéneo de densidade água (−9 a 20 UH), sem septos, calcificação nem realce interno.",
    "bosniak_catI_finding1": "Parede fina (≤ 2 mm), lisa, sem realce mural apreciável",
    "bosniak_catI_finding2": "Conteúdo homogéneo água (−9 a 20 UH) sem septos",
    "bosniak_catI_finding3": "Sinal RM: hiperintensa T2, hipointensa T1 sem restrição de difusão",
    "bosniak_catII_desc": "Cisto minimamente complexo sem realce suspeito. Inclui cistos com poucos septos finos, calcificação fina ou conteúdo hiperdenso sem realce.",
    "bosniak_catII_finding1": "Poucos septos finos (≤ 2 mm) que podem realçar",
    "bosniak_catII_finding2": "Calcificação de qualquer tipo em parede fina ou septos finos",
    "bosniak_catII_finding3": "Cistos hiperdensos ≥ 70 UH ou não-realçantes > 20 UH",
    "bosniak_catIIF_desc": "Cisto minimamente complexo que requer seguimento. Apresenta características ligeiramente mais complexas que Bosniak II, mas sem realce francamente suspeito.",
    "bosniak_catIIF_finding1": "Espessamento mínimo liso (3 mm) de parede ou septos com realce",
    "bosniak_catIIF_finding2": "Múltiplos septos finos (≥ 4) ou complexidade moderada",
    "bosniak_catIIF_finding3": "Sinal heterogéneo em T1 com saturação de gordura (hiperintenso)",
    "bosniak_catIII_desc": "Massa cística indeterminada. Apresenta achados suspeitos como espessamento irregular de parede/septos com realce, mas sem componente claramente nodular.",
    "bosniak_catIII_finding1": "Parede ou septos espessos (≥ 4 mm) ou irregulares com realce",
    "bosniak_catIII_finding2": "Realce mensurável de componentes espessados/irregulares",
    "bosniak_catIII_finding3": "Sem nódulo mural ou septal claramente definido",
    "bosniak_catIV_desc": "Massa cística claramente maligna. Contém componente(s) nodular(es) sólido(s) com realce, indicando carcinoma de células renais até prova em contrário.",
    "bosniak_catIV_finding1": "Nódulo(s) mural(ais) ou septal(ais) com realce (componente sólido)",
    "bosniak_catIV_finding2": "Margens anguladas do nódulo (< 90°) com parede ou septo",
    "bosniak_catIV_finding3": "Componente sólido realçante, com restrição de difusão",
    "bosniak_protocolTitle": "Protocolo TC renal",
    "bosniak_phasePrecontrast": "Fase sem contraste",
    "bosniak_phasePrecontrastDesc": "Medir atenuação basal do cisto (UH). Fundamental para detectar cistos hiperdensos e calcular realce verdadeiro.",
    "bosniak_phaseCorticomedullary": "Fase corticomedular",
    "bosniak_phaseCorticomedullaryDesc": "25–70 s pós-injeção. Útil para detectar realce precoce, mas a fase nefrográfica é preferida para Bosniak.",
    "bosniak_phaseNephrographic": "Fase nefrográfica",
    "bosniak_phaseNephrographicDesc": "80–180 s pós-injeção. Fase ótima para avaliar realce de parede/septos. É a fase mais importante para a classificação.",
    "bosniak_phaseExcretory": "Fase excretora",
    "bosniak_phaseExcretoryDesc": "≥ 3 min. Avaliar relação com sistema coletor e descartar divertículo calicial.",
    "bosniak_enhancementCritTitle": "Critérios de realce",
    "bosniak_enhanceCrit1": "Realce verdadeiro: incremento ≥ 20 UH entre fase sem contraste e nefrográfica",
    "bosniak_enhanceCrit2": "Pseudorrealce: incremento < 10 UH por scatter/beam hardening, não realce verdadeiro",
    "bosniak_enhanceCrit3": "Zona cinza (10–20 UH): considerar RM com subtração para confirmar",
    "bosniak_mriTitle": "Avaliação por RM",
    "bosniak_mriT1": "Pré e pós-Gd com saturação de gordura. Subtração obrigatória para detectar realce sutil.",
    "bosniak_mriT2": "Conteúdo cístico hiperintenso. Os componentes sólidos são relativamente hipointensos.",
    "bosniak_mriDWI": "Útil como complemento. A restrição de difusão pode indicar componente sólido, mas não substitui o realce.",
    "bosniak_mriSubtraction": "Subtração",
    "bosniak_mriSubtractionDesc": "Imprescindível em RM. Subtrai T1 pré-Gd do T1 pós-Gd para isolar realce verdadeiro do sinal intrínseco T1.",
    "bosniak_pitfallsTitle": "Erros diagnósticos frequentes",
    "bosniak_pitfall1": "Confundir pseudorrealce por scatter com realce verdadeiro em cistos pequenos (< 2 cm) adjacentes ao parénquima",
    "bosniak_pitfall2": "Não medir atenuação basal sem contraste — impossível determinar realce verdadeiro sem referência",
    "bosniak_pitfall3": "Classificar cistos hemorrágicos/proteináceos (hiperdensos) como complexos quando NÃO realçam",
    "bosniak_pitfall4": "Aplicar Bosniak a massas com > 25% de componente sólido — a classificação não é desenhada para massas sólidas",
    "bosniak_changesTitle": "Alterações Bosniak 2019 vs. anterior",
    "bosniak_change1": "Eliminação da categoria Bosniak I vs. II baseada em calcificação — a calcificação já não afeta a categoria",
    "bosniak_change2": "Nova definição de limiares de espessura: ≤ 2 mm (fino), 3 mm (minimamente espessado), ≥ 4 mm (espesso)",
    "bosniak_change3": "Incorporação formal de RM como modalidade equivalente a TC para a classificação",
    "bosniak_change4": "Define claramente que o nódulo mural/septal (componente sólido com realce) = Bosniak IV",
    "bosniak_change5": "A regra do 'grau máximo' persiste: a característica individual mais suspeita determina a categoria final",
    "bosniak_indicationsTitle": "Indicações",
    "bosniak_indication1": "Massas renais císticas incidentais detectadas em TC ou RM com contraste",
    "bosniak_indication2": "Seguimento de cistos previamente classificados como Bosniak IIF",
    "bosniak_indication3": "Avaliação pré-operatória de massas renais císticas complexas para planeamento cirúrgico",
    "bosniak_limitationsTitle": "Limitações",
    "bosniak_limitation1": "Não aplicar a massas renais com > 25% de componente sólido (usar classificação de massas sólidas)",
    "bosniak_limitation2": "Não válida sem contraste intravenoso — o realce é pilar fundamental da classificação",
    "bosniak_limitation3": "Excluir massas de etiologia infecciosa/inflamatória conhecida (abscessos, cistos infetados)",
    "bosniak_limitation4": "Não desenhada para massas císticas de origem vascular (aneurismas, MAV renais)",
    "bosniak_followUpTitle": "Seguimento recomendado",
    "bosniak_followUp12": "Não requer seguimento por imagem",
    "bosniak_followUpIIF": "TC ou RM aos 6 e 12 meses, depois anual durante 5 anos. Se progredir → reclassificar.",
    "bosniak_followUpIII": "Cirurgia parcial/radical ou vigilância ativa com imagem cada 6 meses segundo comorbilidades e preferência do paciente.",
    "bosniak_followUpIV": "Tratamento cirúrgico (nefrectomia parcial preferida se tecnicamente viável). Biópsia se necessária confirmação pré-operatória.",
    "bosniak_referencesTitle": "Referências",
    "garden_classification": "Classificação Garden",
    "garden_desc": "Fraturas subcapitais do colo femoral — Garden",
    "garden_criteria": "Classificação de Garden",
    "garden_description": "Sistema de classificação para fraturas subcapitais do colo femoral baseado no grau de deslocamento dos fragmentos ósseos na radiografia AP.",
    "garden_fracturePattern": "Padrão de fratura",
    "garden_trabecularPattern": "Padrão trabecular",
    "garden_chooseOne": "Escolher 1",
    "garden_highestGrade": "O grau mais alto determina a classificação",
    "garden_selectFeatures": "Selecione características",
    "garden_displacement": "Deslocamento",
    "garden_fractureIncomplete": "Fratura incompleta (impactação em valgo, apenas cortical inferior)",
    "garden_fractureCompleteNondisplaced": "Fratura completa, não deslocada (ambas corticais rompidas, alinhadas)",
    "garden_fractureCompletePartial": "Fratura completa, parcialmente deslocada",
    "garden_fractureCompleteFull": "Fratura completa, totalmente deslocada (sem contato entre fragmentos)",
    "garden_trabecularAngulated": "Trabéculas anguladas (padrão de impactação em valgo)",
    "garden_trabecularInterrupted": "Trabéculas interrompidas, alinhadas através da linha de fratura",
    "garden_trabecularDisrupted": "Trabéculas rompidas com rotação da cabeça femoral",
    "garden_trabecularNone": "Sem continuidade trabecular (separação completa)",
    "garden_gI_label": "Incompleta / Impactada em valgo",
    "garden_gII_label": "Completa, não deslocada",
    "garden_gIII_label": "Completa, parcialmente deslocada",
    "garden_gIV_label": "Completa, totalmente deslocada",
    "garden_scoringNote": "O grau Garden final é determinado pelo nível de deslocamento observado. Na prática clínica, os graus I-II (não deslocadas) e III-IV (deslocadas) são agrupados para a tomada de decisões terapêuticas.",
    "garden_reference": "Referência:",
    "garden_conclusionI": "Fratura subcapital do colo femoral classificada como Garden I (fratura incompleta / impactada em valgo). Recomenda-se fixação interna com parafusos canulados.",
    "garden_conclusionII": "Fratura subcapital do colo femoral classificada como Garden II (fratura completa, não deslocada). Recomenda-se fixação interna com parafusos canulados.",
    "garden_conclusionIII": "Fratura subcapital do colo femoral classificada como Garden III (fratura completa, parcialmente deslocada). Recomenda-se artroplastia parcial ou total segundo idade e nível de atividade do paciente.",
    "garden_conclusionIV": "Fratura subcapital do colo femoral classificada como Garden IV (fratura completa, totalmente deslocada). Recomenda-se artroplastia parcial ou total segundo idade e nível de atividade do paciente.",
    "garden_clickToInsert": "Clique para inserir a recomendação no relatório",
    "garden_toggleHighlight": "Mostrar/ocultar destaque",
    "eaton_classification": "Classificação Eaton-Littler",
    "eaton_desc": "Artrose trapeciometacarpiana (rizartrose) — Eaton-Littler",
    "eaton_criteria": "Classificação de Eaton-Littler",
    "eaton_description": "Sistema de classificação radiológica para a artrose trapeciometacarpiana (rizartrose) baseado no estreitamento articular, osteófitos, subluxação e envolvimento da articulação escafotrapézio-trapezoide (ETT).",
    "eaton_jointSpace": "Espaço articular",
    "eaton_osteophytes": "Osteófitos",
    "eaton_subluxation": "Subluxação",
    "eaton_sttJoint": "Articulação ETT",
    "eaton_chooseOne": "Escolher 1",
    "eaton_highestStage": "O estádio mais alto determina a classificação",
    "eaton_selectFeatures": "Selecione características",
    "eaton_jointNormal": "Espaço articular normal ou ligeiramente alargado",
    "eaton_jointSlightNarrowing": "Ligeiro estreitamento do espaço articular",
    "eaton_jointMarkedNarrowing": "Estreitamento marcado ou destruição articular",
    "eaton_jointNarrowingBoth": "Estreitamento marcado de TMC + articulação ETT",
    "eaton_osteoAbsent": "Sem osteófitos",
    "eaton_osteoSmall": "Osteófitos pequenos (< 2 mm)",
    "eaton_osteoLarge": "Osteófitos > 2 mm, esclerose subcondral/cistos",
    "eaton_osteoBothJoints": "Osteófitos nas articulações TMC + ETT",
    "eaton_subluxMinimal": "Subluxação ≤ 1/3 da superfície articular",
    "eaton_subluxSlight": "Ligeira subluxação da articulação TMC",
    "eaton_subluxSignificant": "Subluxação significativa (> 1/3)",
    "eaton_subluxFixed": "Subluxação TMC + deformidade fixa em adução",
    "eaton_sttNormalI": "Articulação ETT normal",
    "eaton_sttNormalII": "Articulação ETT normal",
    "eaton_sttNormalIII": "Articulação ETT normal",
    "eaton_sttAffected": "Articulação ETT afetada (estreitamento, osteófitos, esclerose)",
    "eaton_eI_label": "Pré-artrósico",
    "eaton_eII_label": "Artrose leve",
    "eaton_eIII_label": "Artrose avançada (apenas TMC)",
    "eaton_eIV_label": "Artrose pantrapezoidal (TMC + ETT)",
    "eaton_scoringNote": "O estádio final de Eaton-Littler é determinado pelo achado radiológico de maior gravidade. Os estádios I-II são geralmente tratados de forma conservadora, enquanto os estádios III-IV requerem avaliação cirúrgica.",
    "eaton_reference": "Referência:",
    "eaton_conclusionI": "Artrose trapeciometacarpiana classificada como Eaton-Littler I (estádio pré-artrósico). Recomenda-se tratamento conservador com tala, anti-inflamatórios e reabilitação.",
    "eaton_conclusionII": "Artrose trapeciometacarpiana classificada como Eaton-Littler II (artrose leve). Recomenda-se tratamento conservador ou cirurgia segundo sintomatologia clínica.",
    "eaton_conclusionIII": "Artrose trapeciometacarpiana classificada como Eaton-Littler III (artrose avançada da articulação TMC). Recomenda-se trapeciectomia ou artroplastia.",
    "eaton_conclusionIV": "Artrose trapeciometacarpiana classificada como Eaton-Littler IV (artrose pantrapezoidal, afetação TMC + ETT). Recomenda-se artrodese ou artroplastia total.",
    "snyder_classification": "Classificação de Snyder",
    "snyder_desc": "Roturas completas do manguito rotador — Snyder",
    "snyder_criteria": "Classificação de Snyder",
    "snyder_description": "Sistema de classificação para roturas completas do manguito rotador (supraespinhal e/ou infraespinhal) baseado no diâmetro anteroposterior da rotura e no número de tendões envolvidos.",
    "snyder_tearSize": "Tamanho da rotura (AP)",
    "snyder_tendonCount": "Tendões envolvidos",
    "snyder_chooseOne": "Escolher 1",
    "snyder_highestGrade": "O grau mais alto determina a classificação",
    "snyder_selectFeatures": "Selecione características",
    "snyder_tearSmall": "Rotura completa < 10 mm de diâmetro AP",
    "snyder_tearMedium": "Rotura completa de 10–20 mm de diâmetro AP",
    "snyder_tearLarge": "Rotura completa > 20 mm de diâmetro AP",
    "snyder_tearMassive": "Rotura completa envolvendo ≥ 2 tendões",
    "snyder_tendonSingle": "Um único tendão (supraespinhal ou infraespinhal)",
    "snyder_tendonSingleRetracted": "Um único tendão com retração moderada",
    "snyder_tendonSingleAtrophy": "Um único tendão com retração/atrofia significativa",
    "snyder_tendonMultiple": "Dois ou mais tendões envolvidos",
    "snyder_sC1_label": "Rotura completa pequena (< 10 mm)",
    "snyder_sC2_label": "Rotura completa média (10–20 mm)",
    "snyder_sC3_label": "Rotura completa grande (> 20 mm)",
    "snyder_sC4_label": "Rotura massiva (≥ 2 tendões)",
    "snyder_scoringNote": "O grau Snyder final é determinado pelo achado de maior gravidade. C4 tem prioridade quando dois ou mais tendões estão envolvidos, independentemente do tamanho da rotura.",
    "snyder_reference": "Referência:",
    "snyder_conclusionC1": "Rotura completa do manguito rotador classificada como Snyder C1 (rotura pequena, < 10 mm de diâmetro AP). Recomenda-se reparação artroscópica.",
    "snyder_conclusionC2": "Rotura completa do manguito rotador classificada como Snyder C2 (rotura média, 10–20 mm de diâmetro AP). Recomenda-se reparação artroscópica ou mini-open.",
    "snyder_conclusionC3": "Rotura completa do manguito rotador classificada como Snyder C3 (rotura grande, > 20 mm de diâmetro AP). Recomenda-se reparação aberta ou artroscópica segundo retração e qualidade tecidual.",
    "snyder_conclusionC4": "Rotura completa do manguito rotador classificada como Snyder C4 (rotura massiva envolvendo dois ou mais tendões). Considerar transferência tendinosa ou artroplastia inversa do ombro.",
    "herbert_classification": "Classificação de Herbert-Fisher",
    "herbert_desc": "Fraturas do escafoide cárpico — Herbert-Fisher",
    "herbert_criteria": "Escafoide cárpico · Herbert e Fisher, 1984",
    "herbert_description": "Classifica as fraturas do escafoide cárpico segundo a sua estabilidade e evolução (Herbert e Fisher, 1984) e orienta o tratamento.",
    "herbert_acutePattern": "Fratura aguda",
    "herbert_instability": "Critério de instabilidade",
    "herbert_chronicity": "Evolução",
    "herbert_chooseOne": "Escolher 1",
    "herbert_optional": "Opcional",
    "herbert_highestGrade": "O tipo de maior gravidade determina a classificação",
    "herbert_selectFeatures": "Selecione características",
    "herbert_a1Tubercle": "Fratura do tubérculo",
    "herbert_a2WaistNondisplaced": "Cintura não desviada (confirmada por TC)",
    "herbert_b1DistalOblique": "Oblíqua do terço distal",
    "herbert_b2WaistDisplaced": "Cintura desviada ou móvel",
    "herbert_b3ProximalPole": "Polo proximal",
    "herbert_b4Perilunate": "Fratura-luxação transescafoperilunar",
    "herbert_b5Comminuted": "Cominutiva",
    "herbert_instDisplacement": "Desvio > 1 mm",
    "herbert_instDisi": "DISI: ângulo escafolunar > 60°",
    "herbert_instAngle": "Ângulo intraescafoide lateral > 35°",
    "herbert_instComminution": "Cominução",
    "herbert_instPerilunate": "Parte de uma lesão perilunar",
    "herbert_cDelayed": "Atraso de consolidação",
    "herbert_d1Fibrous": "Pseudoartrose fibrosa (polo proximal habitualmente viável)",
    "herbert_d2Mobile": "Pseudoartrose móvel",
    "herbert_d3Sclerotic": "Pseudoartrose esclerótica, com defeito e deformidade em giba",
    "herbert_d4Avn": "Necrose avascular com colapso e perda da arquitetura",
    "herbert_extB3a": "Ângulo escafolunar < 60°",
    "herbert_extB3b": "Ângulo escafolunar > 60°",
    "herbert_extShortLt2": "Encurtamento < 2 mm",
    "herbert_extShortGt2": "Encurtamento > 2 mm",
    "herbert_extSlac": "Com alterações SLAC",
    "herbert_tA_label": "Aguda estável",
    "herbert_tB_label": "Aguda instável",
    "herbert_tC_label": "Atraso de consolidação",
    "herbert_tD_label": "Pseudoartrose estabelecida",
    "herbert_recA": "Tratamento conservador ou fixação percutânea.",
    "herbert_recB": "Fixação cirúrgica.",
    "herbert_recC": "Cirurgia, frequentemente com enxerto ósseo.",
    "herbert_recD": "Cirurgia, frequentemente com enxerto ósseo.",
    "herbert_scoringNote": "O tipo final é determinado pelo achado de maior gravidade. Qualquer um destes critérios torna a fratura aguda instável (B): desvio > 1 mm, ângulo escafolunar > 60° (DISI), ângulo intraescafoide lateral > 35°, cominução ou lesão perilunar. O polo proximal (B3) é sempre instável pela sua vascularização retrógrada. Confirmar A2 versus B2 com TC.",
    "herbert_reference": "Referência:",
    "herbert_conclusion": "Fratura do escafoide cárpico classificada como Herbert {{subtype}} ({{label}}). {{recommendation}}",
    "tnm_lung_classification": "Classificação TNM Pulmão",
    "tnmLungName": "TNM Pulmão",
    "tnm_lung_desc": "Carcinoma pulmonar não de pequenas células — TNM 7ª edição",
    "tnm_lung_criteria": "Classificação TNM Pulmão",
    "tnm_lung_description": "Sistema de estadiamento para o carcinoma pulmonar não de pequenas células baseado nos descritores de tumor primário (T), gânglios linfáticos regionais (N) e metástases à distância (M), segundo a 7ª edição TNM (IASLC/UICC/AJCC, 2010).",
    "tnm_lung_tumorDescriptor": "Tumor primário (T)",
    "tnm_lung_nodeDescriptor": "Gânglios linfáticos regionais (N)",
    "tnm_lung_metastasisDescriptor": "Metástases à distância (M)",
    "tnm_lung_chooseOne": "Escolher 1",
    "tnm_lung_stageGrouping": "Determinação do estadio",
    "tnm_lung_stage": "Estadio",
    "tnm_lung_selectDescriptors": "Selecione os descritores T, N e M",
    "tnm_lung_survival5y": "Sobrevivência 5 anos",
    "tnm_lung_scoringNote": "O estadio TNM final é determinado combinando os descritores T, N e M. Em presença de M1, o estadio é sempre IV independentemente de T e N.",
    "tnm_lung_reference": "Referência:",
    "tnm_lung_tTX": "TX — Tumor primário não avaliável",
    "tnm_lung_tT0": "T0 — Sem evidência de tumor primário",
    "tnm_lung_tTis": "Tis — Carcinoma in situ",
    "tnm_lung_tT1a": "T1a — Tumor ≤ 2 cm",
    "tnm_lung_tT1b": "T1b — Tumor > 2 cm e ≤ 3 cm",
    "tnm_lung_tT2a": "T2a — Tumor > 3 cm e ≤ 5 cm",
    "tnm_lung_tT2b": "T2b — Tumor > 5 cm e ≤ 7 cm",
    "tnm_lung_tT3": "T3 — Tumor > 7 cm, ou invasão de parede torácica / diafragma / nervo frénico, ou nódulo(s) no mesmo lobo",
    "tnm_lung_tT4": "T4 — Invasão de mediastino, coração, grandes vasos, traqueia, carina, esófago, vértebra; ou nódulo(s) em lobo ipsilateral diferente",
    "tnm_lung_nNX": "NX — Gânglios regionais não avaliáveis",
    "tnm_lung_nN0": "N0 — Sem metástases nos gânglios regionais",
    "tnm_lung_nN1": "N1 — Metástases nos gânglios peribronquiais / hilares ipsilaterais",
    "tnm_lung_nN2": "N2 — Metástases nos gânglios mediastínicos / subcarinais ipsilaterais",
    "tnm_lung_nN3": "N3 — Metástases nos gânglios mediastínicos / hilares contralaterais, escalenos ou supraclaviculares",
    "tnm_lung_mM0": "M0 — Sem metástases à distância",
    "tnm_lung_mM1a": "M1a — Nódulo(s) no pulmão contralateral, derrame pleural / pericárdico maligno",
    "tnm_lung_mM1b": "M1b — Metástases à distância (extratorácica)",
    "tnm_lung_conclusionOculto": "Carcinoma pulmonar em estadio Oculto (TX N0 M0). Recomenda-se completar o estudo de extensão.",
    "tnm_lung_conclusion0": "Carcinoma pulmonar em estadio 0 (Tis N0 M0, carcinoma in situ). Recomenda-se ressecção cirúrgica.",
    "tnm_lung_conclusionIA": "Carcinoma pulmonar em estadio IA (T1a-T1b N0 M0). Recomenda-se ressecção cirúrgica (lobectomia). Sobrevivência a 5 anos: 73%.",
    "tnm_lung_conclusionIB": "Carcinoma pulmonar em estadio IB (T2a N0 M0). Recomenda-se ressecção cirúrgica ± quimioterapia adjuvante. Sobrevivência a 5 anos: 58%.",
    "tnm_lung_conclusionIIA": "Carcinoma pulmonar em estadio IIA (T1-T2a N1, T2b N0). Recomenda-se ressecção cirúrgica mais quimioterapia adjuvante. Sobrevivência a 5 anos: 46%.",
    "tnm_lung_conclusionIIB": "Carcinoma pulmonar em estadio IIB (T2b N1, T3 N0). Recomenda-se ressecção cirúrgica mais quimioterapia adjuvante. Sobrevivência a 5 anos: 36%.",
    "tnm_lung_conclusionIIIA": "Carcinoma pulmonar em estadio IIIA (T1-T2 N2, T3 N1-N2, T4 N0-N1). Recomenda-se quimiorradioterapia com avaliação cirúrgica. Sobrevivência a 5 anos: 24%.",
    "tnm_lung_conclusionIIIB": "Carcinoma pulmonar em estadio IIIB (T4 N2, qualquer T N3). Recomenda-se quimiorradioterapia. Sobrevivência a 5 anos: 9%.",
    "tnm_lung_conclusionIV": "Carcinoma pulmonar em estadio IV (qualquer T, qualquer N, M1). Recomenda-se terapia sistémica (quimioterapia / terapia dirigida / imunoterapia). Sobrevivência a 5 anos: 13%.",
    "tnm_lung_matrixTitle": "Matriz de estadiamento (T × N)",
    "tnm_lung_matrixDesc": "Estadio resultante da combinação dos descritores T e N quando M = M0. Se M1a ou M1b estiver presente, o estadio é sempre IV independentemente de T e N.",
    "tnm_lung_matrixM1Note": "Qualquer T, qualquer N — sempre Estadio IV",
    "tnm_lung_matrixOccult": "Oculto",
    "smartBarPlaceholder": "Escreva aqui...",
    "noCommandsUnderstood": "Não entendi bem o que você quer que eu faça. Poderia ser mais específico, por favor?",
    "bold": "Negrito",
    "italic": "Itálico",
    "underline": "Sublinhado",
    "textColor": "Cor do texto",
    "custom": "Personalizado",
    "untitled": "Relatório sem título",
    "facturationRate": "Faturação semanal",
    "billedReports": "relatórios faturados",
    "vsLastWeek": "vs semana passada",
    "weeklyCompletionRate": "Relatórios semanais",
    "avgEditTime": "Tempo médio por relatório",
    "avgEditTimeSub": "{{count}} relatórios esta semana",
    "avgEditTimeEmpty": "Sem dados disponíveis",
    "byPeriod": {
      "month":  { "facturationRate": "Faturação do mês",          "avgEditTimeSub": "{{count}} relatórios este mês" },
      "week":   { "facturationRate": "Faturação semanal",          "avgEditTimeSub": "{{count}} relatórios esta semana" },
      "day":    { "facturationRate": "Faturação de hoje",          "avgEditTimeSub": "{{count}} relatórios hoje" },
      "last30": { "facturationRate": "Faturação últimos 30 dias",  "avgEditTimeSub": "{{count}} relatórios nos últimos 30 dias" }
    },
    "moreStats": "Ver todas as estatísticas",
    "moreStatsDesc": "Analise sua produtividade e tendências",
    "versionHistory": "Histórico de versões",
    "closePanel": "Fechar painel",
    "saveDocToSeeHistory": "Salve o documento para ver o histórico.",
    "noVersionsSaved": "Nenhuma versão salva ainda.",
    "restoring": "Restaurando…",
    "restoreThisVersion": "Restaurar esta versão",
    "loadMore": "Carregar mais",
    "comparingDiffs": "Comparando diferenças",
    "exitPreview": "Sair da pré-visualização",
    "versionRestored": "Versão restaurada",
    "versionRestoreError": "Não foi possível restaurar a versão",
    "triggerAutosave": "Salvamento automático",
    "triggerManualSave": "Salvamento manual",
    "triggerAiGeneration": "Geração IA",
    "triggerVoiceCommand": "Comando de voz",
    "triggerMagicWrite": "Escrita mágica",
    "triggerTemplateInserted": "Modelo inserido",
    "triggerTemplateChange": "Mudança de modelo",
    "sourceMagicWriting": "Escrita mágica",
    "sourceManual": "Manual",
    "sourceDictation": "Ditado",
    "triggerVersionRestored": "Versão restaurada",
    "standardTemplateHint": "Não indicaste nenhum modelo, por isso usei o modelo padrão.\n Se quiseres, diz-me que modelo usar e aplico-o de imediato.\n Por exemplo: «Usa o modelo de TC de tórax. No parênquima pulmonar identifica-se...».",
    "patientData": "Dados do paciente",
    "patientHistory": "Histórico do paciente",
    "closePatientPanel": "Fechar painel do paciente",
    "demographics": "Demografia",
    "birth": "Nascimento",
    "age": "Idade",
    "sex": "Sexo",
    "studySection": "Estudo",
    "date": "Data",
    "descriptionLabel": "Descrição",
    "clinic": "Clínica",
    "reportHistory": "Histórico de relatórios",
    "signed": "Assinado",
    "reportIssueTitle": "Reportar um problema",
    "reportIssueThanks": "Obrigado pelo seu relato!",
    "reportIssueReview": "Vamos revisá-lo o mais rápido possível e trabalhar para corrigi-lo.",
    "reportIssueDescribe": "Descreva o problema",
    "reportIssuePlaceholder": "Descreva em detalhe o que aconteceu, em qual tela ou ação e como reproduzi-lo...",
    "reportIssueSendError": "Não foi possível enviar o problema. Tente novamente.",
    "reportIssueConsent": "Aceito que a equipe da Ainovis entre em contato comigo para mais detalhes",
    "reportIssueDisclaimer": "Usaremos esta informação unicamente para melhorar nossa ferramenta e resolver o problema reportado.",
    "reportIssueSubmit": "Enviar relato",
    "menuFile": "Arquivo",
    "menuInsert": "Inserir",
    "menuClassifications": "Classificações",
    "menuTemplates": "Modelos",
    "menuSupport": "Suporte",
    "menuCopy": "Copiar",
    "menuShare": "Compartilhar",
    "menuVersionHistory": "Histórico de versões",
    "menuDownloadPdf": "Baixar como PDF",
    "menuPrint": "Imprimir",
    "menuRename": "Renomear",
    "menuDelete": "Excluir",
    "menuLanguage": "Idioma",
    "menuImage": "Imagem",
    "menuTable": "Tabela",
    "insertTable": "Inserir tabela",
    "menuDivider": "Linha divisória",
    "menuChart": "Gráfico",
    "menuShortcuts": "Atalhos de teclado",
    "menuAskCarolina": "Perguntar à Carolina",
    "menuReportIssue": "Reportar um problema",
    "menuExploreTemplates": "Explorar modelos",
    "menuUseAinovisTemplates": "Usar modelos da Ainovis",
    "menuCreateTemplate": "Criar modelo",
    "saveAsTemplate": "Guardar como modelo",
    "templateNameInvalid": "O nome só pode conter letras, números, espaços, hifens, apóstrofos e pontos",
    "templateNameAinovis": "Já existe um modelo Ainovis com esse nome. Escolha outro nome.",
    "templateNameGroup": "O nome do modelo não pode conter o nome do seu grupo.",
    "templateName": "Nome do modelo",
    "contentCopiedToClipboard": "Conteúdo copiado para a área de transferência",
    "errorCopyingContent": "Não foi possível copiar o conteúdo",
    "noSavedDocToDelete": "Não há documento salvo para excluir.",
    "deleteDocumentTitle": "Excluir documento",
    "confirmDeleteDocument": "Tem certeza que deseja excluir este documento? Esta ação não pode ser desfeita.",
    "documentDeleted": "Documento excluído com sucesso.",
    "errorDeletingDocument": "Não foi possível excluir o documento.",
    "errorDeleteForbidden": "Você não tem permissão para excluir este rascunho.",
    "draftNoAccessTitle": "Você não tem acesso a este rascunho",
    "draftNoAccessMessage": "Peça ao autor que o compartilhe com você.",
    "draftNotFoundTitle": "Este rascunho não existe",
    "draftNotFoundMessage": "O autor pode tê-lo excluído.",
    "noContentToExport": "Não há conteúdo para exportar.",
    "browserBlockedPopup": "O navegador bloqueou a janela popup.",
    "saveTemplate": "Salvar modelo",
    "backToReports": "Voltar aos relatórios",
    "untitledTemplate": "Modelo sem título",
    "templateTitleRequired": "Deve adicionar um título ao modelo",
    "actionVersions": "Versões",
    "actionPatients": "Pacientes",
    "actionReportsHistory": "Relatórios anteriores",
    "patientsSidebarTitlePatient": "Dados do paciente",
    "patientsSidebarTitleHistory": "Histórico do paciente",
    "patientsSidebarClose": "Fechar painel do paciente",
    "patientsSidebarNotConnected": "Não conectado",
    "patientsSidebarTabPatient": "Dados do paciente",
    "patientsSidebarTabHistory": "Histórico de relatórios",
    "patientsSidebarSectionDemographics": "Demografia",
    "patientsSidebarSectionStudy": "Estudo atual",
    "patientsSidebarSectionClinical": "Clínica",
    "patientsSidebarLabelBirth": "Nascimento",
    "patientsSidebarLabelAge": "Idade",
    "patientsSidebarLabelSex": "Sexo",
    "patientsSidebarLabelModality": "Modalidade",
    "patientsSidebarLabelDate": "Data",
    "patientsSidebarLabelAccession": "Nº Acesso",
    "patientsSidebarLabelDescription": "Descrição",
    "patientsSidebarLabelReferring": "Médico solicitante",
    "patientsSidebarLabelReason": "Motivo do pedido",
    "patientsSidebarAddReason": "Adicionar motivo do pedido",
    "patientsSidebarAddReasonShort": "Adicionar",
    "patientsSidebarReasonHint": "Você precisa estar conectado a um sistema externo (RIS/PACS) para habilitar esta funcionalidade.",
    "patientsSidebarStudyUid": "Study UID",
    "patientsSidebarSexMale": "Masculino",
    "patientsSidebarSexFemale": "Feminino",
    "patientsSidebarYearsOld": "{{years}} anos",
    "patientsSidebarNoPatientName": "Paciente sem nome",
    "patientsSidebarReportFallbackTitle": "Relatório",
    "patientsSidebarNoReport": "Sem relatório",
    "patientsSidebarHistoryEmpty": "Sem relatórios anteriores disponíveis",
    "patientsSidebarHistoryUnread": "Não foi possível carregar os relatórios",
    "patientsSidebarHistoryCount": "{{studies}} estudos · {{reports}} relatórios",
    "patientSummaryButton": "Resumir",
    "patientSummaryButtonHint": "Resumo dos relatórios anteriores gerado por Carolina",
    "patientSummaryTitle": "Resumo do paciente",
    "patientSummaryRegenerate": "Regenerar",
    "patientSummaryCollapse": "Recolher resumo",
    "patientSummaryExpand": "Expandir resumo",
    "patientSummaryShowMore": "Ver tudo",
    "patientSummaryShowLess": "Ver menos",
    "patientSummaryStepAnalyzing": "A analisar relatórios anteriores ({{count}})…",
    "patientSummaryStepWriting": "A redigir o resumo…",
    "patientSummaryNoPriors": "Não há relatórios anteriores com texto que possam ser analisados.",
    "patientSummaryNoFindings": "Não foram encontrados antecedentes relevantes nos relatórios anteriores.",
    "patientSummaryStale": "Os relatórios anteriores mudaram desde que este resumo foi gerado.",
    "patientSummaryRetry": "Tentar novamente",
    "patientSummaryErrorGeneric": "Não foi possível gerar o resumo.",
    "patientSummaryErrorTimeout": "O resumo demorou demasiado. Tente novamente.",
    "patientSummaryErrorLimits": "Há demasiados relatórios anteriores para resumir de uma só vez.",
    "patientSummaryErrorUnavailable": "O serviço de resumo não está disponível neste momento.",
    "patientSummaryDisclaimer": "Gerado por Carolina às {{time}} · Verifique as referências",
    "patientSummaryReferences": "Referências ({{count}})",
    "patientSummaryViewInReport": "Ver no relatório",
    "actionAiAssistant": "Assistente IA",
    "actionMicQr": "Microfone do telemóvel",
    "micQrSidebarTitle": "Microfone do telemóvel",
    "micQrSidebarClose": "Fechar painel do microfone",
    "micQrStep1": "Abre a câmara do telemóvel.",
    "micQrStep2": "Digitaliza o código QR.",
    "micQrStep3": "Aceita a permissão do microfone.",
    "micQrStep4": "Toca no botão de gravar.",
    "micQrNeedsPermission": "Aceita a permissão do microfone no telemóvel antes de gravar.",
    "micQrLoading": "A gerar código…",
    "micQrError": "Não foi possível criar o código. Tente novamente.",
    "micQrExpired": "O código expirou",
    "micQrExpiresIn": "Expira em {{minutes}} min",
    "micQrHttpsHint": "O telemóvel precisa de HTTPS (ou localhost) para usar o microfone.",
    "micQrRefresh": "Gerar outro código",
    "micQrWaiting": "À espera do telemóvel…",
    "micQrStartRemote": "Ligado ao microfone do telemóvel. Toca para gravar.",
    "micQrConnected": "Telemóvel ligado",
    "micQrConnectedHint": "Toca no botão de gravar.",
    "micQrDisconnect": "Desligar",
    "useTemplate": "Usar modelo",
    "newChat": "Novo chat",
    "closeAiPanel": "Fechar painel de IA",
    "aiHeroText": "Pergunte-me qualquer dúvida que tenha sobre Ainovis",
    "aiPlaceholder": "Escreva uma mensagem...",
    "aiErrorMessage": "Desculpe, não consegui processar sua pergunta. Tente novamente.",
    "aiQuestion1": "Como gero um relatório com a SmartBar?",
    "aiQuestion2": "Como inicio o ditado por voz?",
    "aiQuestion3": "Quais classificações médicas posso usar?",
    "toolbarParagraphStyle": "Estilo de parágrafo",
    "toolbarFontFamily": "Fonte",
    "toolbarStyleNormal": "Texto normal",
    "toolbarStyleH1": "Cabeçalho 1",
    "toolbarStyleH2": "Cabeçalho 2",
    "toolbarStyleH3": "Cabeçalho 3",
    "toolbarStyleH4": "Cabeçalho 4",
    "toolbarStyleH5": "Cabeçalho 5",
    "toolbarApplyStyleToAll": "Aplicar a todos: \"{{style}}\"",
    "toolbarBold": "Negrito (Ctrl+B)",
    "toolbarItalic": "Itálico (Ctrl+I)",
    "toolbarUnderline": "Sublinhado (Ctrl+U)",
    "toolbarStrikethrough": "Tachado",
    "toolbarTextColor": "Cor do texto",
    "toolbarHighlightColor": "Cor de destaque",
    "toolbarNoColor": "Nenhuma",
    "toolbarPresetColors": "Cores predefinidas",
    "toolbarCustomColors": "Cores personalizadas",
    "toolbarAddCustomColor": "Cor personalizada...",
    "toolbarAlignLeft": "Alinhar à esquerda",
    "toolbarAlignCenter": "Centralizar",
    "toolbarAlignRight": "Alinhar à direita",
    "toolbarJustify": "Justificar",
    "toolbarBulletList": "Lista com marcadores",
    "toolbarNumberedList": "Lista numerada",
    "toolbarLineSpacing": "Espaçamento entre linhas",
    "toolbarRemoveSpaceBefore": "Remover espaço antes do parágrafo",
    "toolbarAddSpaceBefore": "Adicionar espaço antes do parágrafo",
    "toolbarRestoreSpaceAfter": "Restaurar espaço após o parágrafo",
    "toolbarRemoveSpaceAfter": "Remover espaço após o parágrafo",
    "toolbarCustomSpacing": "Espaçamento personalizado…",
    "toolbarKeepWithNext": "Manter com o próximo",
    "toolbarKeepLinesTogether": "Manter linhas juntas",
    "toolbarAvoidOrphans": "Evitar linhas órfãs",
    "toolbarPageBreakBefore": "Adicionar quebra de página antes",
    "toolbarDecreaseSize": "Reduzir tamanho",
    "toolbarIncreaseSize": "Aumentar tamanho",
    "toolbarAlignment": "Alinhamento",
    "toolbarSingleSpacing": "Simples",
    "toolbarDoubleSpacing": "Duplo",
    "toolbarZoom": "Zoom",
    "toolbarZoomOut": "Reduzir zoom",
    "toolbarZoomIn": "Aumentar zoom",
    "toolbarUndo": "Desfazer (Ctrl+Z)",
    "toolbarRedo": "Refazer (Ctrl+Y)",
    "toolbarMoreOptions": "Mais opções de formatação",
    "toolbarFindingsMode": "Modo de achados",
    "toolbarFindingsFirst": "Achados no início",
    "toolbarFindingsFirstDesc": "Os achados são colocados acima dos normais",
    "toolbarFindingsInside": "Achados dentro do texto",
    "toolbarFindingsInsideDesc": "Os achados são integrados no corpo do relatório",
    "toolbarHighlightFindings": "Destacar achados",
    "toolbarLineSpacingSingle": "Simples",
    "toolbarLineSpacingDouble": "Duplo",
    "toolbarLanguagePlaceholder": "Idioma"
  },
  "inconsistencies": {
    "label": "Inconsistência",
    "show": "Mostrar",
    "hide": "Descartar",
    "mixedLateralityTerm": "Lateralidades mistas",
    "mixedLateralityReason": "Foram detetadas lateralidades diferentes (DIREITA e ESQUERDA) no mesmo estudo. Verifique se está correto.",
    "missingLateralityTerm": "Lateralidade ausente",
    "missingLateralityReason": "O procedimento requer lateralidade, mas nenhuma (direita ou esquerda) foi detetada na técnica."
  },
  "settings": {
    "title": "Configurações",
    "subtitle": "Personalize o idioma e formato dos relatórios",
    "profile": "Perfil",
    "account": "Conta",
    "preferences": "Preferências",
    "language": "Idioma",
    "languageDescription": "Selecione o idioma da interface do utilizador",
    "theme": "Tema",
    "themeDescription": "Escolha o tema de cor da aplicação",
    "themeOptions": {
      "light": "Claro",
      "dark": "Escuro",
      "system": "Sistema"
    },
    "notifications": "Notificações",
    "security": "Segurança",
    "changePassword": "Alterar palavra-passe",
    "currentPassword": "Palavra-passe atual",
    "privacyPolicy": "Política de privacidade",
    "termsOfService": "Termos de serviço",
    "audio": "Áudio",
    "audioDescription": "Configure o dispositivo de entrada de áudio para ditado",
    "audioDevice": "Dispositivo de áudio",
    "audioDeviceDescription": "Selecione o microfone que deseja usar para ditado",
    "selectMicrophone": "Selecionar microfone",
    "selectedDevice": "Dispositivo selecionado",
    "microphone": "Microfone",
    "session": "Sessão",
    "sessionDescription": "Faça a gestão da sua sessão atual",
    "onboarding": "Tutorial",
    "onboardingDescription": "Veja o tutorial da aplicação novamente",
    "onboardingText": "Se quiser ver o tutorial guiado novamente, clique no botão para reativá-lo. Ele será exibido na próxima vez que aceder aos ecrãs correspondentes.",
    "onboardingButton": "Reativar tutorial",
    "onboardingResetSuccess": "Tutorial reativado com sucesso",
    "logoutText": "Ao sair, será redirecionado para a página de login",
    "signature": "Assinatura",
    "signatureDescription": "Escreva o texto que será inserido ao assinar um relatório",
    "defaultSignatureName": "Dr. Nome Sobrenome",
    "signedBy": "Assinado por",
    "colegiadoLabel": "Nº de inscrição",
    "signatureHint": "Configure o seu número de inscrição e título profissional na secção de administração de utilizadores.",
    "signatureSaved": "Assinatura guardada",
    "deleteSignature": "Eliminar assinatura",
    "generateSignature": "Gerar assinatura",
    "ainovisTemplates": "Modelos da Ainovis",
    "ainovisTemplatesDescription": "Use os modelos predefinidos da Ainovis ao gerar relatórios",
    "ainovisTemplatesText": "Ative esta opção para usar os modelos da Ainovis. Se a desativar, apenas os seus modelos pessoais serão usados."
  },
  "users": {
    "professionalTitle": "Título",
    "professionalTitlePlaceholder": "Dr., Dra., etc.",
    "practitionerIdentifier": "Nº de inscrição",
    "practitionerIdentifierPlaceholder": "Ex: 282812345",
    "practitionerIdentifierSystem": "Sistema de identificação",
    "practitionerIdentifierSystemPlaceholder": "URI da ordem ou registo profissional",
    "title": "Utilizadores",
    "user": "utilizador",
    "usersPlural": "utilizadores",
    "userList": "Lista de utilizadores",
    "addUser": "Adicionar utilizador",
    "editUser": "Editar utilizador",
    "deleteUser": "Eliminar utilizador",
    "userDetails": "Detalhes do utilizador",
    "newUser": "Novo Utilizador",
    "management": "Gestão de Utilizadores",
    "subtitle": "Faça a gestão e visualize informações de utilizadores do sistema",
    "searchPlaceholder": "Pesquisar por nome, e-mail ou código...",
    "sortBy": "Ordenar por",
    "defaultSort": "Padrão (Nome)",
    "nameAsc": "Nome (A-Z)",
    "nameDesc": "Nome (Z-A)",
    "surnameAsc": "Sobrenome (A-Z)",
    "emailAsc": "Email (A-Z)",
    "emailDesc": "Email (Z-A)",
    "roleAsc": "Função (A-Z)",
    "roleDesc": "Função (Z-A)",
    "noUsers": "Nenhum utilizador disponível",
    "showing": "Mostrando",
    "of": "de",
    "firstName": "Nome",
    "lastName": "Sobrenome",
    "role": "Função",
    "roleSuper": "Super",
    "roleAdmin": "Admin",
    "roleSupervisor": "Supervisor",
    "roleUser": "Utilizador",
    "status": "Status",
    "active": "Ativo",
    "inactive": "Inativo",
    "verified": "Verificado",
    "pending": "Pendente",
    "lastLogin": "Último acesso",
    "createSuccess": "Utilizador criado com sucesso",
    "createError": "Erro ao criar utilizador",
    "updateSuccess": "Utilizador atualizado com sucesso",
    "deleteSuccess": "Utilizador eliminado com sucesso",
    "notVerified": "Utilizador não verificado",
    "notVerifiedDescription": "Este utilizador ainda não verificou o seu endereço de e-mail.",
    "resendVerification": "Reenviar e-mail de verificação",
    "resending": "A reenviar...",
    "emailSentSuccess": "E-mail enviado com sucesso",
    "basicInfo": "Informações Básicas",
    "personalInfo": "Informações Pessoais",
    "assignments": "Atribuições",
    "code": "Código",
    "primaryEmail": "E-mail Principal",
    "secondaryEmail": "E-mail Secundário",
    "nationalId": "ID Nacional",
    "birthDate": "Data de Nascimento",
    "address": "Endereço",
    "account": "Conta",
    "notSpecified": "Não especificado",
    "required": "*",
    "optional": "(opcional)",
    "namePlaceholder": "Nome do utilizador",
    "surnamePlaceholder": "Sobrenome do utilizador",
    "emailPlaceholder": "usuario@exemplo.com",
    "email2Placeholder": "opcional@exemplo.com",
    "searchAccountPlaceholder": "Pesquisar conta...",
    "roleRadiologist": "Radiologista",
    "roleRadiologistDesc": "Acesso básico ao sistema",
    "roleSupervisorDesc": "Supervisiona e revisa relatórios",
    "roleAdminDesc": "Faz a gestão de utilizadores na sua conta",
    "roleSuperDesc": "Acesso total ao sistema",
    "nameRequired": "O nome é obrigatório",
    "nameMinLength": "O nome deve ter pelo menos 2 carateres",
    "nameMaxLength": "O nome é muito longo (máximo 100 carateres)",
    "nameInvalidChars": "O nome contém carateres inválidos",
    "surnameRequired": "O sobrenome é obrigatório",
    "surnameMinLength": "O sobrenome deve ter pelo menos 2 carateres",
    "surnameMaxLength": "O sobrenome é muito longo (máximo 100 carateres)",
    "surnameInvalidChars": "O sobrenome contém carateres inválidos",
    "emailRequired": "O e-mail é obrigatório",
    "emailInvalid": "O formato do e-mail é inválido",
    "emailMaxLength": "O e-mail é muito longo (máximo 255 carateres)",
    "email2Invalid": "O formato do e-mail secundário é inválido",
    "email2MaxLength": "O e-mail secundário é muito longo (máximo 255 carateres)",
    "roleRequired": "A função é obrigatória",
    "accountRequired": "A conta é obrigatória",
    "saving": "A guardar...",
    "create": "Criar Utilizador",
    "createWithoutInvite": "Criar sem convidar",
    "update": "Atualizar"
  },
  "accounts": {
    "title": "Contas",
    "account": "conta",
    "accountsPlural": "contas",
    "accountList": "Lista de contas",
    "addAccount": "Adicionar conta",
    "editAccount": "Editar conta",
    "accountDetails": "Detalhes da conta",
    "accountName": "Nome da conta",
    "accountType": "Tipo de conta",
    "newAccount": "Nova conta",
    "management": "Gestão de contas",
    "subtitle": "Faça a gestão de hospitais, utilizadores e licenças",
    "searchPlaceholder": "Pesquisar por nome ou @domínio...",
    "sortBy": "Ordenar por",
    "defaultSort": "Padrão (Atualização)",
    "nameAsc": "Nome (A-Z)",
    "nameDesc": "Nome (Z-A)",
    "newestFirst": "Mais recentes",
    "oldestFirst": "Mais antigos",
    "recentlyModified": "Recentemente modificados",
    "notModified": "Sem modificação",
    "noAccounts": "Nenhuma conta encontrada",
    "tryDifferentSearch": "Tente outros termos de pesquisa",
    "createFirstAccount": "Crie a sua primeira conta para começar",
    "page": "Página",
    "of": "de",
    "domains": "Domínios de e-mail",
    "noDomains": "Sem domínios configurados",
    "licenseLimits": "Limites de licenças",
    "administrators": "Administradores",
    "supervisors": "Supervisores",
    "radiologists": "Radiologistas",
    "unlimited": "Ilimitado",
    "metadata": "Metadados",
    "createdAt": "Criado em",
    "updatedAt": "Atualizado em",
    "deleteConfirm": "Tem certeza que deseja eliminar esta conta?",
    "deleteWarning": "Esta ação não pode ser desfeita e eliminará todos os dados associados.",
    "deletion": {
      "title": "Eliminar a conta {{name}}",
      "lead": "A eliminação arrasta tudo o que depende da conta. Não pode ser desfeita.",
      "loading": "A calcular o alcance...",
      "planFailed": "Não foi possível calcular o alcance da eliminação.",
      "groups": "grupos",
      "usersToDelete": "utilizadores serão eliminados",
      "usersToDeactivate": "utilizadores serão desativados (têm histórico clínico)",
      "gateways": "gateways serão desativados no Hub",
      "hubUnreachable": "O Hub de integração não responde. A conta não pode ser eliminada sem desativar primeiro os seus gateways.",
      "confirm": "Eliminar em cascata",
      "success": "Conta eliminada: {{groups}} grupos, {{deleted}} utilizadores eliminados e {{deactivated}} desativados."
    },
    "deleteSuccess": "Conta eliminada com sucesso",
    "createSuccess": "Conta criada com sucesso",
    "updateSuccess": "Conta atualizada com sucesso",
    "nameRequired": "O nome é obrigatório",
    "invalidNumber": "Deve ser um número positivo",
    "invalidDomain": "Formato inválido. Deve ser como @dominio.com",
    "domainExists": "Este domínio já foi adicionado",
    "addDomain": "Adicionar domínio",
    "domainPlaceholder": "@exemplo.com",
    "optional": "(Opcional, deixe vazio para ilimitado)",
    "generalInfo": "Informações Gerais",
    "additionalInfo": "Informações adicionais",
    "creationDate": "Data de criação",
    "lastUpdate": "Última atualização",
    "deleteAccount": "Eliminar conta?",
    "deleteAccountMessage": "Esta ação eliminará permanentemente a conta {name} e não pode ser desfeita.",
    "cancel": "Cancelar",
    "confirmDelete": "Sim, eliminar",
    "accountNameField": "Nome da conta",
    "requiredField": "*",
    "domainsDescription": "Adicione os domínios de e-mail permitidos para esta conta",
    "domainInputPlaceholder": "Ex: @hospital.com",
    "limitsDescription": "Defina o máximo de utilizadores por função",
    "maxAdmins": "Máximo de administradores",
    "maxSupervisors": "Máximo de supervisores",
    "maxRadiologists": "Máximo de radiologistas",
    "packageTypeTitle": "Tipo de pacote",
    "packageTypeDescription": "Selecione o nível de pacote para esta conta",
    "packageType": "Pacote",
    "packageBronze": "Bronze",
    "packageSilver": "Silver",
    "packageGold": "Gold",
    "distributorTitle": "Distribuidor",
    "distributorDescription": "Selecione o distribuidor associado a esta conta. Pode criar novos distribuidores.",
    "distributor": "Distribuidor",
    "hierarchy": {
      "title": "Estrutura organizacional",
      "manage": "Gerir organização",
      "manageHint": "Grupos, equipa, modelos institucionais e políticas, no painel de organização."
    },
    "distributorDefault": "Predefinido",
    "distributorCreate": "Criar distribuidor…",
    "distributorCreatePlaceholder": "Ex.: NOVO_DISTRIBUIDOR",
    "distributorNameRequired": "Introduza um nome válido"
  },
  "groups": {
    "management": "Gestão de grupos",
    "subtitle": "Gerir os grupos médicos da plataforma",
    "newGroup": "Novo grupo",
    "editGroup": "Editar grupo",
    "searchPlaceholder": "Pesquisar por nome ou NIF...",
    "group": "grupo",
    "groupsPlural": "grupos",
    "noGroups": "Nenhum grupo encontrado",
    "tryDifferentSearch": "Tente outros termos de pesquisa",
    "createFirstGroup": "Crie o seu primeiro grupo para começar",
    "generalInfo": "Informação Geral",
    "contactInfo": "Informação de Contacto",
    "accountInfo": "Informação da Conta",
    "code": "Código",
    "groupName": "Nome do grupo",
    "groupNamePlaceholder": "Ex: Grupo de Diagnóstico Norte",
    "nationalId": "NIF",
    "nationalIdPlaceholder": "Ex: 123456789",
    "address": "Morada",
    "addressPlaceholder": "Ex: Avenida da Saúde 45",
    "email": "Email de contacto",
    "emailPlaceholder": "Ex: contacto@grupo.com",
    "phone": "Telefone de contacto",
    "phonePlaceholder": "Ex: +351 21 123 4567",
    "account": "Conta",
    "selectAccount": "Selecionar conta...",
    "delete": "Eliminar",
    "edit": "Editar",
    "cancel": "Cancelar",
    "saving": "A guardar...",
    "update": "Atualizar",
    "create": "Criar grupo",
    "deleteSuccess": "Grupo eliminado com sucesso",
    "createSuccess": "Grupo criado com sucesso",
    "updateSuccess": "Grupo atualizado com sucesso",
    "nameRequired": "O nome é obrigatório",
    "addressRequired": "A morada é obrigatória",
    "emailRequired": "O email é obrigatório",
    "phoneRequired": "O telefone é obrigatório",
    "accountRequired": "A conta é obrigatória",
    "invalidEmail": "Formato de email inválido",
    "notSpecified": "Não especificado",
    "notAssigned": "Não atribuída",
    "close": "Fechar",
    "loadError": "Erro ao carregar grupos"
  },
  "validation": {
    "required": "Este campo é obrigatório",
    "invalidEmail": "E-mail inválido",
    "passwordTooShort": "A palavra-passe deve ter pelo menos 8 carateres",
    "passwordMismatch": "As palavras-passe não coincidem",
    "invalidFormat": "Formato inválido"
  },
  "navigation": {
    "home": "Início",
    "dashboard": "Painel",
    "reports": "Relatórios",
    "templates": "Modelos",
    "users": "Utilizadores",
    "accounts": "Contas",
    "settings": "Configurações"
  },
  "templates": {
    "title": "Modelos",
    "preparationNoticeLabel": "Há modelos a guardar.",
    "preparationNoticeHint": "Espere antes de usar o ditado.",
    "preparationNoticeDetail": "Os modelos já foram guardados, mas ainda estão a ser preparados para o ditado. Espere que este aviso desapareça.",
    "galleryTitle": "Galeria de modelos",
    "viewAllTemplates": "Ver todos os modelos",
    "count": "{{count}} modelos",
    "all": "Todos",
    "personal": "Pessoais",
    "emptyPersonal": "Não tem modelos associados.",
    "createFirst": "Criar novo modelo",
    "newTemplate": "Novo modelo",
    "searchPlaceholder": "Procurar modelo...",
    "allTypes": "Todos os tipos",
    "allSources": "Todas as origens",
    "allLanguages": "Todos os idiomas",
    "customSelect": "Selecionar idioma",
    "showing": "Mostrando",
    "template": "modelo",
    "templates_plural": "modelos",
    "searching": "A pesquisar modelos...",
    "loadingMore": "A carregar mais modelos...",
    "empty": "Nenhum modelo encontrado.",
    "emptyHint": "Adicionar novos modelos",
    "newTemplateTitle": "Novo Modelo",
    "details": "Detalhes",
    "selectTemplate": "Selecione um modelo…",
    "templateName": "Nome do modelo",
    "templateNameLabel": "Nome do Modelo",
    "templatePlaceholder": "Ex: RM_JOELHO_CONTRASTE",
    "isBlock": "É um modelo patológico?",
    "no": "Não (Normal)",
    "yes": "Sim (Patológico)",
    "activationWord": "Palavra de ativação",
    "activationWordLabel": "Palavra de ativação:",
    "activationWordPlaceholder": "Ex: TUMOR, LESÃO, etc.",
    "activationWordInfo": "A palavra de ativação permite distinguir modelos da mesma área anatômica. Por exemplo, para pancreatite você pode usar 'PANCREATITE' para diferenciá-la de outros modelos de pâncreas.",
    "autoUppercase": "Será salvo automaticamente em maiúsculas",
    "standard": "Padrão",
    "defaultBadge": "Padrão",
    "setDefault": "Usar «{{name}}» como modelo padrão",
    "unsetDefault": "Deixar de usar «{{name}}» como modelo padrão",
    "defaultSet": "«{{name}}» é agora o seu modelo padrão",
    "defaultUnset": "Já não tem um modelo padrão próprio",
    "defaultError": "Não foi possível alterar o modelo padrão",
    "standardInfoTitle": "Modelo Padrão",
    "standardInfoBody": "",
    "standardInfoIntro": "O modelo padrão é projetado para estudos radiológicos gerais. Utiliza marcadores dinâmicos na técnica que são substituídos automaticamente ao gerar o laudo.",
    "standardInfoTechniqueTitle": "Técnica",
    "standardInfoTechniqueBody": "A técnica inclui marcadores dinâmicos entre parênteses retos duplos (como [[lateralidade]], [[sequências]], [[regiões_anatómicas]]) que o sistema substitui automaticamente pelos valores correspondentes ao gerar o laudo.",
    "standardInfoTechniqueExample": "Realiza-se TC [[regiões_anatómicas]] com técnica helicoidal [[protocolo]].",
    "standardInfoFindingsTitle": "Achados",
    "standardInfoFindingsBody": "Os achados são redigidos como texto descritivo contínuo em formato de prosa, descrevendo as estruturas avaliadas e suas características de forma narrativa.",
    "standardInfoUseCaseTitle": "Quando usar?",
    "standardInfoUseCaseBody": "Ideal para estudos radiológicos gerais: TC de extremidades, RM de joelho, coluna, abdômen, ultrassonografias, radiografias, etc.",
    "infoExample": "Ex.:",
    "content": "3. Conteúdo do Modelo",
    "contentPlaceholder": "Arraste um ficheiro .txt aqui ou escreva o conteúdo...",
    "dragFile": "📄 Arraste um ficheiro .txt aqui",
    "referenceIf": "4. Referência de Ativação (REFERENCE_IF)",
    "alwaysActive": "Sempre ativo (ALWAYS)",
    "referenceIfWarning": "⚠️ Não pode haver dois REFERENCE_IF = ALWAYS para o mesmo procedimento",
    "activationWordRequired": "Palavra de ativação:",
    "activationWordInputPlaceholder": "Digite a palavra de ativação",
    "language": "Código de Idioma",
    "type": "Tipo",
    "saving": "A guardar...",
    "saveChanges": "Guardar Alterações",
    "createTemplate": "Criar Modelo",
    "creating": "A criar modelo...",
    "nameRequired": "O nome do modelo é obrigatório",
    "activationRequired": "Deve inserir uma palavra de ativação para modelos patológicos",
    "activationOrAlways": "Deve inserir uma palavra de ativação ou marcar \"Sempre ativo\"",
    "supportsBilaterality": "ℹ️ Suporta unilateralidade e bilateralidade",
    "viewOtherTechnique": "Revisar modelo com bilateralidade/unilateralidade contrária",
    "relatedTechnique": "Técnica relacionada (Bilateral/Unilateral)",
    "contentRequired": "O conteúdo do modelo não pode estar vazio",
    "techniqueRequired": "O conteúdo da técnica não pode estar vazio",
    "findingsRequired": "O conteúdo dos achados não pode estar vazio",
    "conclusionRequired": "O conteúdo da conclusão não pode estar vazio",
    "technique": "Técnica",
    "techniquePlaceholder": "Escreva o conteúdo da técnica",
    "techniquePlaceholderStandard": "Ex: Realiza-se RM do joelho [[lateralidade]] [[sequências]].",
    "findings": "Achados",
    "findingsBlocks": "Achados",
    "findingsPlaceholder": "Escreva o conteúdo dos achados",
    "findingsPlaceholderStandard": "Ex: Estruturas ósseas com sinal medular normal, sem edema ou lesões focais.",
    "conclusion": "Conclusão",
    "conclusionPlaceholder": "Escreva o conteúdo da conclusão",
    "conclusionPlaceholderStandard": "Ex: Exame sem achados significativos.",
    "noProcedures": "Não existem procedimentos associados ao seu modelo",
    "templateCreated": "Modelo criado com sucesso",
    "errorSaving": "Erro ao guardar o modelo",
    "normal": "Normal",
    "pathology": "Patologia",
    "urgent": "Urgente",
    "followUp": "Acompanhamento",
    "pediatric": "Pediátrico",
    "USER": "Utilizador",
    "STANDARD": "Padrão",
    "AINOVIS": "Ainovis",
    "procedureAssignment": "Atribuir Procedimentos",
    "procedureAssignmentExplanation": "Quando gerar um relatório e um dos procedimentos atribuídos for detetado, este modelo será automaticamente usado para gerar o relatório.",
    "groupFull": "Grupo cheio",
    "principal": "Principal",
    "complementary": "Complementar",
    "procedure": "Procedimento",
    "addPrincipalFirst": "Primeiro adicione um procedimento principal",
    "dragOrAssign": "Arraste ou atribua procedimentos",
    "suggestedProcedures": "Procedimentos sugeridos",
    "highRelevance": "Alta relevância",
    "mediumRelevance": "Média relevância",
    "assignAsPrincipal": "Atribuir como Principal",
    "assignAsComplementary": "Atribuir como Complementar",
    "confirmSelection": "Confirmar seleção",
    "remove": "Remover",
    "resolving": "A resolver modelo com procedimentos...",
    "contentLabel": "Modelo",
    "availableProcedures": "Procedimentos disponíveis",
    "add": "Adicionar",
    "assigned": "Atribuído",
    "dropHere": "Solte aqui para criar um grupo",
    "clickToAddProcedure": "Clique ou arraste um procedimento para adicioná-lo",
    "singleExample": "Único",
    "singleExampleValue": "Joelho → Um único procedimento",
    "multiExample": "Multi",
    "multiExampleValue": "Joelho + Perna → Vários procedimentos juntos",
    "expandList": "Expandir lista",
    "collapseList": "Recolher lista",
    "activationReference": "Referência de ativação",
    "alwaysActiveDesc": "O modelo ativa sempre",
    "customReference": "Referência personalizada",
    "customReferenceDesc": "Escreva uma palavra-chave de ativação",
    "customActivation": "Ativação personalizada",
    "selectDestination": "Selecionar destino",
    "whereToAdd": "Onde quer adicionar",
    "addToExisting": "Adicionar a existente",
    "willCreateMulti": "Criará um Multi-procedimento",
    "willCreateSingle": "Criará um Procedimento único",
    "full": "Cheio",
    "createNewSection": "Criar novo",
    "createNewProcedure": "Criar como Procedimento único",
    "assignedProcedures": "Procedimentos atribuídos",
    "item": "item",
    "items": "itens",
    "examples": "Exemplos",
    "singleProcedure": "Procedimento único",
    "multiProcedure": "Multi-procedimento",
    "collapse": "Recolher",
    "expand": "Expandir",
    "dropToCreate": "Solte aqui para criar novo",
    "templateContent": "Conteúdo do modelo",
    "block": "Patológico",
    "howToTemplates": "Como funcionam os modelos",
    "chipLegendSelector": "Seletor",
    "chipLegendPlaceholder": "Marcador",
    "chipInsertHint": "Clique em um campo ou escreva <kbd>/</kbd> para inserir",
    "stepConfigureTemplate": "Configurar",
    "stepSelectMarkers": "Marcadores",
    "stepAssignProcedures": "Procedimentos",
    "analyzeTemplate": "Analisar modelo",
    "assignProcedures": "Atribuir procedimentos",
    "saveTemplate": "Guardar modelo",
    "blocksHint": "Os modelos patológicos só requerem achados e uma palavra de ativação. Técnica e conclusão são omitidas.",
    "normalHint": "Os modelos normais incluem técnica, achados e conclusão.",
    "standardHint": "Texto livre para descrever achados sem estrutura fixa.",
    "cancelConfirmTitle": "Descartar alterações?",
    "cancelConfirmMessage": "Você tem alterações não salvas. O que deseja fazer?",
    "discardChanges": "Descartar",
    "keepEditing": "Continuar editando",
    "draftSaved": "Rascunho guardado",
    "draftSavedJustNow": "Rascunho guardado",
    "fieldRequired": "Este campo é obrigatório",
    "procedureStepIntro": "Passo 1: Clique em um procedimento para atribuí-lo.",
    "procedureStepGroup": "Passo 2: Se houver grupos, escolha onde adicioná-lo.",
    "procedureStepConfirm": "Passo 3: Confirme a seleção quando terminar.",
    "confirmDelete": "Tem certeza de que deseja eliminar este modelo? Todas as versões associadas (bilateral/unilateral) e suas relações com procedimentos serão removidas.",
    "voiceChipTemplate": "Usa o modelo",
    "voiceChipTemplatesHint": "Dita «Usa o modelo ...» ou seleciona",
    "copyAsPersonal": "Copiar como pessoal",
    "copying": "A copiar...",
    "copySuccess": "Copiado!",
    "copyError": "Erro ao copiar o modelo",
    "copyConflictTitle": "Conflito de procedimentos",
    "copyConflictMessage": "Já existem modelos pessoais para os procedimentos atribuídos a este modelo:",
    "copyConflictHint": "Para usar este modelo, deve atribuir uma palavra de ativação para diferenciá-lo dos existentes.",
    "copyWithActivation": "Copiar com ativação",
    "help": {
      "title": "Como criar modelos",
      "intro": "Os modelos permitem gerar relatórios radiológicos de forma rápida e consistente. Escreva o texto base do relatório e adicione <strong>campos variáveis</strong> onde precisar de valores dinâmicos.",
      "selectorTitle": "Seletor",
      "selectorDesc": "Define uma lista de opções possíveis para um campo. Ao gerar o relatório, uma delas será escolhida. Opcionalmente, pode marcar um <strong>valor padrão</strong> que será usado se não for indicado outro.",
      "exampleInEditor": "Exemplo no editor:",
      "selectorExampleChip": "preservado / aumentado / diminuído: *preservado*",
      "selectorDetail": "Isto significa: as opções são «preservado», «aumentado» e «diminuído». Se não for especificado outro, <strong>«preservado»</strong> será usado como padrão. O padrão é opcional — se não o indicar, as opções serão exibidas sem valor pré-selecionado.",
      "placeholderTitle": "Marcador",
      "placeholderDesc": "Um marcador genérico que será <strong>substituído</strong> por um valor concreto ao gerar o relatório (uma descrição, uma medida, um achado, etc.).",
      "placeholderExampleChip": "achado",
      "placeholderDetail": "Este marcador será substituído pelo texto correspondente quando o relatório final for gerado.",
      "tipTitle": "💡 Dica",
      "tipText": "Escreva <kbd>/</kbd> no editor para abrir o menu rápido de inserção de campos, ou use os botões da barra superior de cada seção.",
      "ok": "Entendido"
    },
    "all": "Todos",
    "personal": "Pessoais",
    "source": "Origem",
    "galleryNormalPrefix": "Galeria de ",
    "galleryBlockPrefix": "Galeria de ",
    "galleryBlockSuffix": "",
    "gallerySubtitle": "Gerencie seus modelos e blocos de laudo",
    "countShown": "{{count}} modelos",
    "countShown_one": "{{count}} modelo",
    "countShown_other": "{{count}} modelos",
    "blocksCountShown": "{{count}} blocos",
    "blocksCountShown_one": "{{count}} bloco",
    "blocksCountShown_other": "{{count}} blocos",
    "blocksWord": "Blocos",
    "templatesWord": "modelos",
    "myTemplates": "Os seus modelos",
    "import": "Importar modelo",
    "importTemplates": "Importar modelos",
    "importDropTitle": "Largue um DOCX, PDF ou TXT aqui",
    "importDropActive": "Largue os ficheiros aqui",
    "importDropHint": "Ou clique para selecionar ficheiros",
    "importAddMore": "Adicione mais ficheiros ou continue",
    "importFilesCount": "{{count}} ficheiros",
    "importTotalSize": "{{count}} ficheiros · {{size}} de {{limit}}",
    "importTotalTooLarge": "O tamanho total dos ficheiros excede o limite de {{limit}}",
    "importProcessingN": "A processar o documento {{current}} de {{total}}…",
    "importFormats": "Formatos suportados: .docx, .pdf, .txt · Máx. 25 MB no total",
    "importInvalidFormat": "Formato não suportado. Utilize um ficheiro .docx, .pdf ou .txt",
    "importProcessing": "A processar o documento…",
    "importSaving": "A importar…",
    "importSaveFailed": "Não foi possível importar os modelos",
    "importPartialFailure": "Não foi possível importar: {{titles}}",
    "importDone": "{{created}} modelos criados e {{replaced}} substituídos",
    "importSkippedAinovis": "Ignorados por coincidirem com modelos Ainovis: {{titles}}",
    "importFailed": "Não foi possível processar o documento",
    "importEmpty": "Não foi encontrado nenhum modelo no documento.",
    "importRemoveFile": "Remover ficheiro",
    "importSplitTitle": "Dividir documento",
    "importSplitHint": "Escolha como separar os modelos do documento.",
    "importSplitAi": "Deteção por IA",
    "importSplitAiHint": "A IA deteta cada modelo do documento.",
    "importSplitPageBreaks": "Quebras de página",
    "importSplitPageBreaksHint": "Um modelo por cada página do documento.",
    "importSplitHorizontalLine": "Linha horizontal",
    "importSplitHorizontalLineHint": "Divide o documento em cada linha horizontal.",
    "importPreviewTitle": "Pré-visualização",
    "importFoundCount": "{{count}} modelos encontrados",
    "importSplitBy": "Dividir por",
    "importNameLabel": "Nome do modelo",
    "importWordCount": "{{count}} palavras",
    "importNoConflict": "Não existe nenhum modelo com este nome.",
    "importReplaces": "Substitui «{{name}}»",
    "importAinovisConflict": "Já existe um modelo Ainovis com esse nome",
    "importAinovisConflictFull": "Já existe um modelo Ainovis com esse nome. Altere-o para poder importá-lo.",
    "importDuplicateInDocument": "Nome repetido neste documento",
    "importDuplicateInDocumentFull": "Outro modelo deste documento já usa esse nome. Altere-o para poder importá-lo.",
    "importEmptyName": "Dê-lhe um nome para poder importá-lo",
    "importUntitled": "Sem nome",
    "importBlocked": "Corrija {{count}} nome(s) para importar",
    "importNameLabel": "Nome do modelo",
    "importFilledPerReport": "Preenchido em cada relatório",
    "importSummary": "{{total}} de {{found}} selecionados",
    "importChooseAnother": "Escolher outro ficheiro",
    "importConfirm": "Importar {{count}} modelos",
    "tabMine": "Pessoais",
    "tabShared": "Institucionais",
    "tabAinovis": "Ainovis",
    "filterStandard": "Padrão",
    "loading": "A carregar modelos...",
    "editTitle": "Editar modelo",
    "saveEdit": "Guardar alterações",
    "filterSource": "Origem",
    "filterLanguage": "Idioma",
    "normalTab": "Modelos",
    "blocksTab": "Blocos",
    "filters": "Filtros",
    "deleteTitle": "Eliminar modelo",
    "deleteConfirm": "Tem a certeza de que deseja eliminar <strong>{{name}}</strong>? Esta ação eliminará todas as versões deste modelo e não pode ser revertida.",
    "deleting": "A eliminar…",
    "delete": "Eliminar",
    "bulkDeleteTitle": "Eliminar modelos",
    "bulkDeleteMessage": "Tem a certeza de que pretende eliminar {{count}} modelos? Todas as suas versões serão eliminadas e a ação não pode ser anulada.",
    "selectedCount": "{{count}} selecionados",
    "selectTemplate": "Selecionar «{{name}}»",
    "tabNormal": "Modelos",
    "tabBlocks": "Blocos",
    "previewLabel": "Pré-visualização:",
    "apply": "Aplicar",
    "cancel": "Cancelar"
  },
  "recommendations": {
    "title": "Sugestões",
    "show": "Mostrar sugestões",
    "hide": "Ocultar sugestões",
    "list": "Sugestões disponíveis",
    "block": "Bloco",
    "classification": "Classificação",
    "loading": "A carregar sugestões…",
    "error": "Não foi possível atualizar todas as sugestões.",
    "noTemplate": "Selecione um modelo para ver sugestões.",
    "empty": "Ainda não há utilizações com este modelo.",
    "expandName": "Ler nome completo",
    "collapseName": "Recolher nome",
    "remove": "Remover {{name}} das sugestões"
  },
  "blocks": {
    "sectionContentPlaceholder": "Escreva aqui o conteúdo que será inserido na secção...",
    "namePlaceholder": "Nome do bloco (ex: Pancreatite aguda)",
    "createHint": "Este conteúdo será inserido na secção onde o arrastar.",
    "empty": "Sem blocos",
    "createFirst": "Criar bloco",
    "createCard": "Criar bloco",
    "deleteTitle": "Eliminar bloco",
    "deleteConfirm": "Tem a certeza de que deseja eliminar <strong>{{name}}</strong>? Esta ação não pode ser revertida.",
    "deleting": "A eliminar…",
    "delete": "Eliminar",
    "cancel": "Cancelar",
    "sidebarTitle": "Blocos",
    "searchToPin": "Pesquisar bloco...",
    "noResults": "Sem resultados",
    "expand": "Expandir",
    "collapse": "Fechar",
    "addToTemplate": "Adicionar",
    "unpin": "Desafixar",
    "pinnedLoadError": "Os blocos fixados não estão disponíveis. Pode continuar a usar os blocos.",
    "preview": "Pré-visualização",
    "removeAssociation": "Remover da lista"
  },
  "classificationCarousel": {
    "searchPlaceholder": "Pesquisar classificação...",
    "empty": "Nenhuma classificação encontrada",
    "descriptions": {
      "FLEISCHNER": "Seguimento de nódulos pulmonares incidentais na TC.",
      "TI-RADS": "Risco de malignidade de nódulos da tiroide na ecografia.",
      "PI-RADS": "Suspeita de cancro da próstata clinicamente significativo na RM.",
      "BOSNIAK_2019": "Estratificação de massas renais quísticas por TC ou RM.",
      "GARDEN": "Fraturas subcapitais do colo do fémur segundo o deslocamento.",
      "EATON_LITTLER": "Estadiamento da rizartrose trapeziometacárpica.",
      "SNYDER": "Roturas completas do manguito rotador segundo o tamanho e os tendões afetados.",
      "HERBERT_FISCHER": "Fraturas do escafoide segundo a estabilidade e a evolução."
    }
  },
  "classificationRequest": {
    "title": "Solicitar classificação",
    "close": "Fechar",
    "successTitle": "Obrigado pelo seu pedido!",
    "successSub": "Analisaremos a sua sugestão e trabalharemos para adicionar a classificação.",
    "intro": "Considera que falta uma classificação? Diga-nos qual precisa e avaliaremos a sua adição.",
    "descriptionLabel": "Descreva a classificação que necessita",
    "descriptionPlaceholder": "Indique o nome da classificação, a especialidade ou tipo de estudo em que é utilizada e quaisquer detalhes relevantes...",
    "submitError": "Não foi possível enviar o pedido. Tente novamente.",
    "allowContact": "Aceito que a equipa da Ainovis me contacte para obter mais detalhes",
    "disclaimer": "Utilizaremos esta informação exclusivamente para avaliar e desenvolver novas classificações.",
    "submitting": "A enviar…",
    "submit": "Enviar pedido",
    "requestClassification": "Solicitar classificação"
  },
  "keyboardShortcuts": {
    "title": "Atalhos de teclado",
    "close": "Fechar",
    "groupDictation": "Ditado",
    "dictationStart": "Começar a gravar",
    "dictationSend": "Enviar áudio",
    "dictationSendAlt": "Enviar áudio",
    "dictationPauseResume": "Pausar / retomar ditado",
    "dictationCancel": "Cancelar áudio",
    "groupTextFormat": "Formatação de texto",
    "bold": "Negrito",
    "italic": "Itálico",
    "underline": "Sublinhado",
    "strikethrough": "Riscado",
    "groupAlignment": "Alinhamento",
    "alignLeft": "Alinhar à esquerda",
    "alignCenter": "Centrar",
    "alignRight": "Alinhar à direita",
    "justify": "Justificar",
    "groupEditing": "Edição",
    "undo": "Desfazer",
    "redo": "Refazer",
    "selectAll": "Selecionar tudo",
    "copy": "Copiar",
    "cut": "Cortar",
    "paste": "Colar",
    "save": "Guardar",
    "groupIndent": "Avanço",
    "indent": "Aumentar avanço",
    "unindent": "Reduzir avanço",
    "groupView": "Vista",
    "zoomIn": "Aumentar zoom",
    "zoomOut": "Reduzir zoom",
    "zoomReset": "Repor zoom",
    "key_space": "Espaço",
    "key_enter": "Enter",
    "key_esc": "Esc",
    "key_tab": "Tab",
    "key_shift": "Shift"
  },
  "aiSidebar": {
    "title": "Carolina",
    "newChat": "Nova conversa",
    "closePanel": "Fechar painel de IA",
    "heroText": "Pergunte-me qualquer dúvida que tenha sobre o Ainovis",
    "inputPlaceholder": "Escreva uma mensagem...",
    "errorMessage": "Desculpe, não consegui processar a sua pergunta. Tente novamente.",
    "question1": "Como gero um relatório com a SmartBar?",
    "question2": "Como inicio o ditado por voz?",
    "question3": "Quais classificações médicas posso usar?"
  },
  "diffModal": {
    "badge": "Conversão para modelo",
    "progressOptions": "opções",
    "title": "Marcadores detetados no texto",
    "subtitle": "Revise as alterações propostas para converter este relatório em um modelo reutilizável",
    "closeLabel": "Fechar modal",
    "selectMarkers": "Selecionar marcadores",
    "slotsTitle": "Opções de construção de modelo",
    "slotsSubtitle": "Selecione quais marcadores aplicar. Os textos correspondentes serão substituídos.",
    "globalMode": "Modo Global",
    "individualMode": "Modo Individual",
    "useGlobalMarker": "Usar marcador global",
    "globalMarkerDescription": "Aplicará o mesmo marcador a todas as regiões anatómicas",
    "finalResult": "Resultado final",
    "previewBadge": "Visualização",
    "defaultValue": "Valor padrão",
    "unspecified": "Não especificado",
    "defaultHint": "As partes destacadas usam valores padrão. Selecione todas as opções para confirmar.",
    "infoTitle": "O que são marcadores?",
    "infoDescription": "Marcadores (ex: [região anatômica], [lateralidade]) são campos que serão preenchidos automaticamente ao usar este modelo, permitindo reutilizá-lo para diferentes casos.",
    "warningTitle": "Complete todas as seleções",
    "warningDescription": "Faltam {count} opções para selecionar. Os slots não selecionados estão destacados.",
    "keepOriginal": "Manter original",
    "applyTemplate": "Aplicar modelo",
    "lateralityDisabledByRegion": "As lateralidades estão desativadas porque as regiões anatómicas já as incluem",
    "regionDisabledByLaterality": "As regiões anatómicas estão desativadas porque há lateralidades selecionadas",
    "flexibilityTitle": "Modelo mais flexível",
    "flexibilityDescription": "Ao escolher marcadores, seu relatório será mais versátil. Os campos marcados serão preenchidos automaticamente de acordo com o procedimento, permitindo reutilizar este modelo para múltiplos casos sem edição manual.",
    "noMarkersTitle": "Sem marcadores selecionados",
    "noMarkersDescription": "Selecione pelo menos um marcador para aplicar alterações à técnica, ou continue para usar o texto original.",
    "replace": "Substituir",
    "insert": "Inserir"
  },
  "editor": {
    "sectionTitleEditToast": "Lembre-se de que pode editar os títulos predefinidos nas configurações"
  },
  "errors": {
    "authInvalidCredentials": "Email ou palavra-passe incorretos",
    "authInvalidToken": "Sessão inválida ou expirada",
    "authTokenExpired": "A sua sessão expirou. Por favor, faça login novamente",
    "authMissingToken": "Deve fazer login para aceder",
    "authUserNotFound": "Utilizador não encontrado",
    "authUserAlreadyExists": "Este utilizador já existe",
    "authInactiveUser": "Sua conta está desativada. Entre em contato com o administrador",
    "authInsufficientPermissions": "Não tem permissões suficientes para esta ação",
    "authValidationError": "Erro na validação de dados",
    "validationError": "Por favor, verifique os dados inseridos",
    "templateNotFound": "Modelo não encontrado",
    "templateValidationError": "Erro nos dados do modelo",
    "templateRetrievalError": "Erro ao obter modelos",
    "templateAlreadyExists": "Já existe um modelo com esse nome",
    "templateNameDuplicate": "Já existe um modelo com esse nome para este utilizador",
    "templateReferenceIfConflictAlways": "Já existe um modelo \"{{templateName}}\" para a combinação de procedimentos: {{procedureNames}}. Só pode existir um modelo padrão por combinação de procedimentos.",
    "templateReferenceIfConflict": "Já existe um modelo \"{{templateName}}\" com a palavra de ativação \"{{referenceIf}}\" para a combinação de procedimentos: {{procedureNames}}. Por favor, use uma palavra de ativação diferente.",
    "templateNoTemplatesFound": "Nenhum modelo encontrado para este utilizador",
    "templateInvalidFormat": "Formato de modelo inválido",
    "templateAccessDenied": "Não tem acesso a este modelo",
    "blockLimitReached": "Atingiu o limite de {{limit}} blocos. Elimine um para poder criar outro.",
    "reportNotFound": "Relatório não encontrado",
    "reportValidationError": "Erro nos dados do relatório",
    "reportGenerationError": "Erro ao gerar relatório",
    "reportSaveError": "Erro ao guardar relatório",
    "reportAlreadyExists": "Já existe um relatório com esse identificador",
    "reportRetrievalError": "Erro ao obter relatórios",
    "reportModalityNotFound": "A modalidade selecionada não existe",
    "reportAccessDenied": "Não tem acesso a este relatório",
    "reportDataInvalid": "Os dados do relatório não são válidos",
    "reportMissingField": "Campos obrigatórios ausentes no relatório",
    "reportInvalidFormat": "Formato de relatório inválido",
    "reportInvalidGenerationRequest": "Solicitação de geração inválida",
    "reportApiError": "Erro ao conectar com o serviço de relatórios",
    "reportServiceError": "Erro no serviço de relatórios",
    "reportAlignmentError": "Erro durante o alinhamento do relatório",
    "reportNoModalityOrRegions": "Não foi possível detetar modalidade ou regiões anatómicas no texto",
    "reportTemplatesNotFoundForProcedure": "Nenhum modelo encontrado para o seu procedimento e idioma",
    "reportTemplatesFoundForDifferentType": "Não foram encontrados modelos do tipo solicitado para o seu procedimento, mas existem modelos do tipo {{availableType}}",
    "reportTemplateType_STANDARD": "achados no início ou achados dentro do texto",
    "reportsTemplateNotFound": "Não há modelo disponível para este descritivo. Pode criar um para usá-lo",
    "reportsTemplateIncomplete": "O modelo está incompleto e não pode ser usado para gerar o relatório",
    "reportsTemplateContentNotFound": "Conteúdo do modelo não encontrado",
    "reportsTemplateContentIncomplete": "O conteúdo do modelo está incompleto",
    "reportsPromptNotFound": "O prompt necessário para a geração não foi encontrado",
    "reportsFindingsGenerationError": "Erro ao gerar os achados do relatório",
    "reportsConclusionGenerationError": "Erro ao gerar a conclusão do relatório",
    "reportsSectionGenerationError": "Erro ao gerar uma secção do relatório",
    "reportsParallelGenerationError": "Erro durante a geração paralela do relatório",
    "reportsInvalidGenerationParameters": "Parâmetros de geração inválidos",
    "reportsAlignmentError": "Erro durante o alinhamento do relatório",
    "reportsPreSaveReviewError": "Erro na revisão prévia ao salvamento",
    "reportsLlmServiceError": "Erro no serviço de inteligência artificial",
    "reportLanguageCodeNotFound": "O código de idioma solicitado não foi encontrado",
    "reportInactiveTemplate": "O modelo selecionado está inativo",
    "reportProcedureNotFound": "O procedimento solicitado não foi encontrado",
    "reportAnatomicalRegionNotFound": "A região anatómica solicitada não foi encontrada",
    "reportVariantNotFound": "A variante solicitada não foi encontrada",
    "reportTemplateNotFound": "Modelo do relatório não encontrado",
    "ainovisApiError": "Erro no serviço de IA",
    "ainovisConnectionError": "Erro de conexão com o serviço de IA",
    "ainovisTimeoutError": "O serviço de IA demorou muito para responder",
    "ainovisInvalidAudioFormat": "Formato de áudio inválido",
    "ainovisAudioFileSizeExceeded": "O ficheiro de áudio é muito grande",
    "ainovisMissingAudioFile": "Nenhum ficheiro de áudio fornecido",
    "sttServiceError": "Erro no serviço de transcrição",
    "sttValidationError": "Erro na validação dos dados de transcrição",
    "sttMissingField": "Campos obrigatórios ausentes para transcrição",
    "sttProcessingError": "Erro ao processar áudio",
    "sttApiError": "Erro ao conectar com o serviço de transcrição",
    "sttNoVoiceDetected": "Nenhuma voz detetada no áudio",
    "sttAudioProcessingError": "Erro ao processar o ficheiro de áudio",
    "sttNoAudioChunks": "Nenhum fragmento de áudio válido foi gerado",
    "sttTranscriptionError": "Erro na transcrição de voz para texto",
    "sttNoTranscriptionResults": "Nenhum resultado de transcrição obtido",
    "sttEmptyTranscript": "A transcrição resultou vazia",
    "sttInvalidAudioFile": "O ficheiro de áudio é inválido ou está corrompido",
    "sttAudioFormatNotSupported": "O formato de áudio não é suportado",
    "emailSendFailed": "Erro ao enviar e-mail",
    "emailInvalidConfig": "Configuração de e-mail inválida",
    "emailInvalidAddress": "Endereço de e-mail inválido",
    "emailTemplateNotFound": "Modelo de e-mail não encontrado",
    "emailTemplateRenderError": "Erro ao renderizar e-mail",
    "emailConnectionError": "Erro de conexão com o servidor de e-mail",
    "emailAuthenticationError": "Erro de autenticação com o servidor de e-mail",
    "networkError": "Erro de conexão. Verifique a sua conexão com a internet",
    "noResponse": "O servidor não está respondendo. Tente novamente",
    "requestSetupError": "Erro ao processar solicitação",
    "unexpectedError": "Ocorreu um erro inesperado"
  },
  "billing": {
    "studies": "Estudos",
    "revenue": "Receita (€)",
    "modality": {
      "rx": "Radiografia",
      "eco": "Ecografia",
      "tc": "TC",
      "rm": "RM"
    }
  },
  "statistics": {
    "dateRange": "Jan 15 – Fev 15, 2026",
    "sections": {
      "productionVolume": "Produção e volume",
      "performanceEfficiency": "Desempenho e eficiência",
      "billing": "Faturamento",
      "realtimeActivity": "Atividade em tempo real"
    },
    "kpi": {
      "reportsToday": "Relatórios hoje",
      "activeRadiologists": "Radiologistas ativos",
      "averageTime": "Tempo médio",
      "templateUsage": "Uso de modelos",
      "vsYesterday": "12.3% vs ontem",
      "thisWeek": "+2 esta semana",
      "vsAvg": "0.8 min vs méd.",
      "thisMonth": "5% este mês"
    },
    "charts": {
      "reportsPerMonth": "Relatórios gerados por mês",
      "reportsPerMonthSubtitle": "Últimos 30 dias — Total: 22.487",
      "reportsPerMonthBadge": "+18% mensal",
      "billing": "Faturamento por modalidade",
      "billingSubtitle": "Tarifa ouro · Volume e receita",
      "billingBadge": "🪩 Tarifa ouro",
      "billingMonthly": "Tendência de receita mensal",
      "billingMonthlySubtitle": "Últimos 6 meses · Receita por modalidade",
      "topRadiologists": "Métricas por radiologista",
      "topRadiologistsSubtitle": "Relatórios esta semana por radiologista",
      "mostUsedTemplates": "Procedimentos mais informados",
      "mostUsedTemplatesSubtitle": "Distribuição por tipo",
      "anatomicalRegions": "Achados por procedimento",
      "anatomicalRegionsSubtitle": "Número de achados por procedimento",
      "heatmap": "Comparativo por radiologista",
      "heatmapSubtitle": "Relatórios por radiologista e modalidade",
      "reportsByModality": "Relatórios por modalidade",
      "reportsByModalitySubtitle": "Distribuição estatística (box plot)",
      "timePerRadiologist": "Tempo de geração por radiologista",
      "timePerRadiologistSubtitle": "Min. médio vs volume",
      "correlationMatrix": "Matriz de correlação diagnóstica",
      "correlationMatrixSubtitle": "Concordância Pearson entre radiologistas (20 estudos)",
      "correlationLegend": "Coeficiente de correlação (Pearson)",
      "frequentFindings": "Achados frequentes",
      "frequentFindingsSubtitle": "Frequência por tipo de achado",
      "weeklyComparison": "Comparação semanal",
      "weeklyComparisonSubtitle": "Top 5 — Atual vs anterior",
      "realtimeFeed": "Feed em tempo real",
      "realtimeFeedSubtitle": "Últimos relatórios",
      "live": "Ao vivo",
      "average": "Média",
      "reports": "relatórios",
      "currentMonth": "Mês atual",
      "previousMonth": "Mês anterior",
      "currentWeek": "Semana atual",
      "previousWeek": "Semana anterior",
      "reportsLabel": "Relatórios",
      "avgMinutes": "Min. médio",
      "volume": "Volume",
      "timeMins": "Tempo (min)",
      "time": "Tempo"
    },
    "days": {
      "mon": "Seg",
      "tue": "Ter",
      "wed": "Qua",
      "thu": "Qui",
      "fri": "Sex",
      "sat": "Sáb",
      "sun": "Dom"
    },
    "specialties": {
      "neuroradiology": "Neurorradiologia",
      "musculoskeletal": "Musculoesquelético",
      "chest": "Tórax",
      "abdomen": "Abdome",
      "breast": "Mama"
    },
    "templateNames": {
      "ctBrain": "TC Cérebro",
      "xrayChest": "RX Tórax",
      "mriKnee": "RM Joelho",
      "ctAbdomen": "TC Abdome",
      "usThyroid": "US Tireoide",
      "other": "Outros"
    },
    "regions": {
      "head": "Cabeça",
      "chest": "Tórax",
      "abdomen": "Abdome",
      "spine": "Coluna",
      "extremities": "Extremidades",
      "pelvis": "Pelve"
    },
    "findings": {
      "noFindings": "Sem achados",
      "pulmonaryNodule": "Nódulo pulmonar",
      "discHerniation": "Hérnia de disco",
      "pleuralEffusion": "Derrame pleural",
      "fracture": "Fratura",
      "renalMass": "Massa renal",
      "aneurysm": "Aneurisma",
      "stenosis": "Estenose",
      "calcification": "Calcificação",
      "hepaticCyst": "Cisto hepático"
    },
    "feed": {
      "minAgo": "Há {{value}} min"
    },
    "additionalTemplate": {
      "title": "Gerar versão complementar",
      "infoBanner": "Foi detetado que este modelo pode ter uma versão complementar (bilateral/unilateral). À esquerda, indique que tipo de versão está a escrever aqui. O modelo original será guardado automaticamente como a versão oposta. Por exemplo, se escolher 'Unilateral', o que escrever aqui será a versão unilateral e o modelo original será guardado como bilateral.",
      "selectVersion": "Qual tipo de versão é?",
      "selectionHint": "Indique se a versão complementar que está a escrever é bilateral ou unilateral.",
      "bilateral": "Bilateral",
      "bilateralDescription": "A versão complementar se aplica a ambos os lados (ambos joelhos, ambos ombros, etc.)",
      "unilateral": "Unilateral",
      "unilateralDescription": "A versão complementar se aplica a um único lado com rótulo [lateralidade].",
      "selectedVersion": "Versão {{option}} selecionada",
      "noSelection": "Selecione um tipo de versão",
      "editContent": "Conteúdo da versão complementar",
      "edited": "Editado",
      "editHint": "Modifique os campos para definir o conteúdo da versão complementar. Este será o conteúdo que será guardado.",
      "technique": "Técnica",
      "techniquePlaceholder": "Escreva a técnica da versão complementar...",
      "findings": "Achados",
      "findingsPlaceholder": "Escreva os achados da versão complementar...",
      "impression": "Conclusão",
      "impressionPlaceholder": "Escreva a conclusão da versão complementar...",
      "skipGeneration": "Continuar sem adicional",
      "save": "Guardar versão"
    }
  },
  "onboarding": {
    "skip": "Pular",
    "next": "Próximo",
    "previous": "Anterior",
    "finish": "Entendi!",
    "tryIt": "Experimente!",
    "example": "Exemplo",
    "interactionPending": "Digite no editor para continuar",
    "interactionDone": "Perfeito! Pode continuar",
    "welcomeTitle": "Bem-vindo ao Ainovis!",
    "welcomeDesc": "Parece que é a sua primeira vez aqui. Gostaria de fazer um tour rápido para conhecer as ferramentas principais?",
    "skipTour": "Agora não",
    "startTour": "Iniciar tour",
    "reportCreate": {
      "editorTitle": "Editor de ditado",
      "editorDesc": "Aqui aparecerá o seu ditado. Pode digitar diretamente ou usar o microfone para ditar o estudo.",
      "micTitle": "Ditado por voz",
      "micDesc": "Pressione o microfone para iniciar o ditado por voz. O microfone funciona no idioma da aplicação. Se não se sentir confortável, pode alterar o idioma nas definições.",
      "generateTitle": "Gerar relatório",
      "generateDesc": "Depois de ditar ou digitar a descrição do estudo, pressione este botão para gerar automaticamente o relatório.",
      "modeTitle": "Modo automático / manual",
      "modeDesc": "Alterne entre modo automático (Ainovis seleciona o modelo) e manual (escolhe o modelo a ser usado).",
      "speedModeTitle": "Velocidade de geração",
      "speedModeDesc": "Escolha entre modo rápido (menor latência) ou preciso (maior qualidade na geração do relatório).",
      "settingsTitle": "Configurações do relatório",
      "settingsDesc": "Configure o idioma, tipo de modelo e tipo de conclusão antes de gerar seu relatório.",
      "tryRomTitle": "Agora experimente!",
      "tryRomDesc": "Digite no editor uma ressonância magnética (RM) do joelho. Pode copiar o exemplo ou escrever o que preferir. Isso mostrará como o Ainovis gera um relatório.",
      "tryRomHint": "Digite uma RM do joelho...",
      "tryRomExample": "RM do joelho normal",
      "tryGenerateTitle": "Gere seu primeiro relatório!",
      "tryGenerateDesc": "Agora pressione o botão de envio para gerar o seu relatório. O Ainovis processará o que escreveu e criará um relatório completo."
    },
    "reportEdit": {
      "lateralMenuTitle": "Menu lateral",
      "lateralMenuDesc": "Neste painel lateral encontrará os parâmetros do relatório. Se veio do ecrã de criação, as configurações que definiu (idioma, tipo de modelo, modo) já estarão aplicadas aqui.",
      "lateralMenuParamsTitle": "Regenerar com novos parâmetros",
      "lateralMenuParamsDesc": "Daqui pode alterar o idioma, tipo de relatório, tipo de conclusão ou velocidade e regenerar o relatório com os novos parâmetros. Também pode criar novas versões diretamente.",
      "patientBannerTitle": "Dados do paciente",
      "patientBannerDesc": "Aqui pode associar os dados do paciente ao relatório: nome, ID, idade, sexo, data do estudo e motivo da consulta. Também pode aceder a estudos anteriores do paciente para comparar ou reutilizar relatórios anteriores.",
      "mainEditorTitle": "Editor do relatório",
      "mainEditorDesc": "Este é o editor principal onde o relatório gerado é exibido, dividido em seções (Técnica, Achados, Conclusão). Pode editar o texto livremente, ditar por voz, e as alterações são guardadas automaticamente como rascunho.",
      "versionTabsTitle": "Versões do relatório",
      "versionTabsDesc": "Cada vez que regenera o relatório ou cria um ecrã em branco, uma nova versão é criada. As abas na parte inferior permitem navegar entre versões, fechar as que não precisa ou criar uma nova versão vazia com o botão +.",
      "actionsTitle": "Ações do relatório",
      "actionsDesc": "Use 'Copiar' para copiar o relatório para a área de transferência, 'Enviar' para guardar o relatório como definitivo, ou 'Eliminar' para descartar completamente o rascunho."
    },
    "home": {
      "welcomeTitle": "O seu painel de controlo",
      "welcomeDesc": "Este é o seu painel principal. Daqui pode criar novos relatórios, carregar áudio para ditado em lote e aceder a todo o seu histórico de trabalho.",
      "createBtnTitle": "Criar relatório",
      "createBtnDesc": "Pressione este botão para criar um novo relatório do zero. O editor será aberto onde poderá ditar ou digitar o estudo.",
      "uploadBtnTitle": "Carregar áudio",
      "uploadBtnDesc": "Carregue ficheiros de áudio com múltiplos ditados. O Ainovis transcreverá e separará automaticamente em estudos individuais.",
      "performanceTitle": "Resumo de atividade",
      "performanceDesc": "Aqui pode ver as suas estatísticas: relatórios criados, tempo economizado e tendências de produtividade. Pressione 'Ver mais estatísticas' para aceder ao painel completo.",
      "templatesTitle": "Modelos",
      "templatesDesc": "O separador Modelos reúne os seus modelos de relatório completos, prontos a usar ao gerar um relatório. Pode criar novos, editar existentes ou usar os partilhados pela sua equipa.",
      "blocksTitle": "Blocos",
      "blocksDesc": "Mude para o separador Blocos: aqui vê os blocos, fragmentos reutilizáveis (parágrafos, achados, descrições) que pode inserir em qualquer relatório para escrever mais depressa.",
      "reportListTitle": "Histórico de trabalho",
      "reportListDesc": "Aqui encontrará todos os seus rascunhos, relatórios guardados, relatórios partilhados consigo e lotes de ditado. Use as abas para filtrar."
    },
    "reportEditV2": {
      "smartBarTitle": "SmartBar — A sua barra inteligente",
      "smartBarDesc": "A SmartBar é a sua ferramenta principal. Digite o texto descritivo do estudo ou dite por voz e pressione enviar para gerar automaticamente o relatório com Carolina. Também pode usá-la para editar secções específicas.",
      "canvasTitle": "Editor do relatório",
      "canvasDesc": "Este é o editor principal onde o relatório gerado é exibido, dividido em secções editáveis. Pode modificar o texto livremente e as alterações são guardadas automaticamente.",
      "toolbarTitle": "Barra de ferramentas",
      "toolbarDesc": "Personalize o formato do texto: fonte, tamanho, negrito, itálico, alinhamento, listas e mais. Funciona como qualquer editor de texto enriquecido.",
      "findingsModeTitle": "Modos de redação",
      "findingsModeDesc": "Aqui escolhe como os achados são redigidos: «Achados no início» agrupa-os no topo, acima do texto normal; «Achados dentro do texto» integra-os no corpo do relatório. Pode mudar de modo a qualquer momento.",
      "menuBarTitle": "Barra de menu",
      "menuBarDesc": "Aceda a todas as funções: gestão de ficheiros, inserção de elementos (imagens, tabelas, gráficos), classificações médicas, modelos e suporte.",
      "classificationsTitle": "Classificações médicas",
      "classificationsDesc": "Aceda a classificações padronizadas como Fleischner, TI-RADS, PI-RADS, Bosniak e mais. Selecione os parâmetros e a classificação será inserida automaticamente no seu relatório.",
      "versionsTitle": "Histórico de versões",
      "versionsDesc": "Este é o histórico de versões do laudo. Cada envio, regeneração ou aplicação de um modelo guarda aqui uma versão. Os passos que alteraram cada versão ficam agrupados por data para comparar, pré-visualizar e restaurar qualquer versão anterior.",
      "patientsTitle": "Pacientes",
      "patientsDesc": "Neste painel você pesquisa e associa o paciente do exame. Ao selecioná-lo, os dados dele e os exames anteriores ficam ligados ao laudo para consultá-los ou reutilizar laudos anteriores.",
      "patientsNotIntegrated": "Esta funcionalidade ainda não está integrada. Para ver os dados e o histórico do paciente, o laudo deve ser aberto a partir de um sistema externo (RIS/PACS).",
      "reportsHistoryTitle": "Laudos anteriores",
      "reportsHistoryDesc": "Aqui vê o histórico de laudos guardados e pode consultá-los para comparar achados com exames antigos.",
      "micQrTitle": "Microfone do celular",
      "micQrDesc": "Digitalize este código com o celular para usá-lo como microfone de ditado sem fio. O código expira após algum tempo; se desconectar, gere-o novamente aqui.",
      "aiBtnTitle": "Assistente IA — Carolina",
      "aiBtnDesc": "Abra o painel da Carolina, a sua assistente de IA. Pode fazer-lhe perguntas sobre o relatório, pedir sugestões ou consultar dúvidas médicas relacionadas.",
      "testTemplateTitle": "Crie o seu primeiro modelo",
      "testTemplateDesc": "Clique no cartão « CRIAR MODELO »: preencheremos o nome e um relatório de exemplo por si.",
      "testTemplateSaveTitle": "Guarde o seu modelo",
      "testTemplateSaveDesc": "O modelo já está preenchido com um relatório de RM do joelho de exemplo. Prima « Guardar modelo » para terminar.",
      "testTemplatePending": "Guarde o modelo para continuar",
      "autoFillTemplateName": "Teste RM joelho",
      "autoFillTemplateSectionTechnique": "TÉCNICA",
      "autoFillTemplateTechniqueBody": "Estudo de RM do joelho direito em sequências DP FS e T1 nos três planos, sem administração de contraste endovenoso.",
      "autoFillTemplateSectionFindings": "ACHADOS",
      "autoFillTemplateFindingsBody": "Meniscos de morfologia e intensidade de sinal normais, sem evidência de rotura. Ligamentos cruzados e colaterais íntegros. Cartilagem articular preservada. Não se observa derrame articular significativo. Sinal da medula óssea normal.",
      "autoFillTemplateSectionConclusion": "CONCLUSÃO",
      "autoFillTemplateConclusionBody": "Estudo de RM do joelho direito dentro da normalidade.",
      "testBlockTitle": "Crie o seu primeiro bloco",
      "testBlockDesc": "Clique no cartão « Criar bloco »: preencheremos um fragmento reutilizável de exemplo por si. Basta premir « Guardar ».",
      "testBlockPending": "Guarde o bloco para continuar",
      "autoFillBlockName": "Rotura do menisco interno",
      "autoFillBlockContent": "Rotura horizontal do corno posterior do menisco interno, com extensão à superfície articular inferior.",
      "testReportTitle": "Dite o seu primeiro relatório à Carolina",
      "testReportDesc": "Prima o microfone e diga em voz alta o comando abaixo. É assim que vai trabalhar todos os dias: a falar, não a escrever.",
      "testReportPending": "Diga o comando em voz alta para continuar",
      "voiceGateIdle": "Prima o microfone e diga o comando em voz alta.",
      "voiceGateSayThis": "Diga em voz alta:",
      "voiceGateNoMic": "Não posso usar o microfone",
      "voiceGatePlaceholder": "Use o microfone →",
      "voiceGateChecking": "A ouvir o que disse…",
      "voiceGateHeard": "Entendi:",
      "voiceGateMissingTemplate": "Falta nomear o seu modelo.",
      "voiceGateMissingBlock": "Falta nomear o seu bloco.",
      "voiceGateRetry": "Repita o comando tal como aparece acima.",
      "voiceGateTypeFallback": "Também o pode escrever na barra.",
      "voiceGateError": "Não foi possível transcrever o áudio. Tente novamente.",
      "testReportExample": "Usa o modelo {{template}} e adiciona o bloco {{block}}"
    }
  },
  "voiceHelp": {
    "title": "Comandos de voz",
    "intro": "Enquanto grava, pode usar comandos de voz para editar o relatório. Também pode simplesmente ditar texto e este será inserido na posição do cursor. Aqui estão os comandos disponíveis:",
    "deleteTitle": "Apagar texto",
    "deleteDesc": "Remove texto do relatório. Pode especificar uma secção concreta.",
    "deleteEx1": "Apaga o paciente apresenta dor",
    "deleteEx2": "Remove na secção achados a massa hepática",
    "updateTitle": "Modificar texto",
    "updateDesc": "Substitui um texto por outro. Use 'por' para indicar o novo valor.",
    "updateEx1": "Altera paciente por indivíduo",
    "updateEx2": "Substitui na secção técnica sequência FLAIR por sequência T2",
    "insertTitle": "Inserir texto",
    "insertDesc": "Adiciona novo texto ao relatório. Pode indicar uma secção ou uma posição relativa (antes/depois de).",
    "insertEx1": "Insere o paciente apresenta bom estado geral",
    "insertEx2": "Adiciona na secção achados massa de 3 cm",
    "insertEx3": "Insere na secção técnica com sequências em T1 depois de RM de joelho",
    "insertEx4": "Adiciona este conteúdo antes de achados",
    "insertSectionTitle": "Inserir secção",
    "insertSectionDesc": "Cria uma nova secção no relatório. Pode indicar a posição relativa a outra secção.",
    "insertSectionEx1": "Insere uma nova secção técnica",
    "insertSectionEx2": "Adiciona secção notas antes da conclusão",
    "selectTitle": "Selecionar opções",
    "selectDesc": "Quando o sistema mostra opções numeradas, pode selecionar, alterar ou apagar opções concretas por número.",
    "selectEx1": "Seleciona o um e o dois",
    "selectEx2": "Escolhe desde o 1 até o 4",
    "selectEx3": "Altera o primeiro",
    "selectEx4": "Apaga o 4",
    "selectEx5": "Altera todos",
    "generateTitle": "Gerar relatório",
    "generateDesc": "Gera ou regenera o relatório completo.",
    "generateEx1": "Gerar relatório",
    "dictationTitle": "Ditado e pontuação",
    "dictationDesc": "Pode ditar sinais de pontuação e formatação com a voz.",
    "dictationEx1": "ponto → .",
    "dictationEx2": "vírgula → ,",
    "dictationEx3": "dois pontos → :",
    "dictationEx4": "nova linha → quebra de linha",
    "dictationEx5": "novo parágrafo → quebra de parágrafo",
    "tip": "💡 Os comandos funcionam com prefixos opcionais como o nome do assistente (Carolina), expressões de cortesia (por favor) ou cumprimentos informais (olá). Também toleram pontuação gerada pelo reconhecimento de voz."
  },
  "batch": {
    "title": "Ditado em lote",
    "uploadSubtitle": "Carregue um ficheiro de áudio com vários relatórios",
    "transcribingSubtitle": "A transcrever áudio...",
    "reviewSubtitle": "Reveja e corrija os estudos detetados",
    "generatingSubtitle": "A gerar relatórios...",
    "stepUpload": "Carregar áudio",
    "stepReview": "Rever",
    "transcriptionComplete": "Transcrição concluída — {{count}} estudos detetados",
    "transcriptionError": "Erro ao transcrever o áudio",
    "noStudies": "Nenhum estudo encontrado. Certifique-se de usar o formato [Paciente ID].",
    "batchSaved": "Lote guardado com sucesso — {{count}} estudos",
    "saveError": "Erro ao guardar o lote",
    "invalidFormat": "Formato não suportado. Use ficheiros .wav, .mp3, .ogg ou .webm",
    "durationExceeded": "A duração total dos ficheiros de áudio não pode exceder 30 minutos",
    "transcribingAudio": "A transcrever áudio...",
    "transcribingHint": "O áudio está a ser processado. Isto pode demorar alguns segundos.",
    "dropHere": "Largue o ficheiro aqui",
    "uploadTitle": "Carregue o seu ficheiro de áudio",
    "uploadHint": "Arraste um ficheiro para aqui ou clique para selecionar",
    "supportedFormats": "Formatos suportados: .wav, .mp3, .ogg, .webm",
    "useMockData": "Usar dados de exemplo",
    "processAudio": "Processar áudio",
    "pause": "Pausar",
    "playAll": "Reproduzir tudo",
    "unifiedHint": "Cada estudo está separado por [Paciente ID]. Prima ▶ junto a cada paciente para ouvir o seu segmento de áudio.",
    "studiesDetected": "{{count}} estudos detetados",
    "scrollToBottom": "Ir para o final",
    "goToEnd": "Ir para o final",
    "saving": "A guardar lote...",
    "playSegment": "Reproduzir segmento",
    "unifiedPlaceholder": "[Paciente 12345678]\nDescritivo do estudo...\n\n[Paciente 87654321]\nOutro estudo...",
    "generateAll": "Gerar todos"
  },
  "voiceCommands": {
    "noTextToDelete": "Nenhum texto para eliminar foi especificado",
    "editorNotAvailable": "Editor não disponível",
    "completeUpdatesBeforeDelete": "Conclua ou cancele as atualizações pendentes antes de fazer eliminações",
    "textNotFound": "\"{{text}}\" não encontrado",
    "textNotFoundInDocument": "\"{{text}}\" não encontrado no documento",
    "couldNotDeleteText": "Não foi possível eliminar o texto",
    "noPendingOperations": "Nenhuma operação pendente. Use primeiro o comando DELETE, UPDATE ou INSERT.",
    "noMatchesFound": "Nenhuma correspondência marcada encontrada",
    "noIndicesSpecified": "Nenhum índice especificado",
    "invalidIndices": "Índices inválidos: {{indices}}. Intervalo válido: 1-{{max}}",
    "noMatchesForIndices": "Nenhuma correspondência encontrada para os índices especificados",
    "noMatchesForIndicesDetail": "Nenhuma correspondência encontrada para os índices especificados: {{indices}}",
    "noTextToUpdate": "Nenhum texto para atualizar foi especificado",
    "noReplacementText": "Nenhum texto de substituição foi especificado",
    "completeDeletesBeforeUpdate": "Conclua ou cancele as eliminações pendentes antes de fazer atualizações",
    "couldNotUpdateText": "Não foi possível atualizar o texto",
    "updateExtensionNotAvailable": "A extensão de atualização não está disponível",
    "noMarkedElements": "Nenhum elemento marcado encontrado no documento",
    "noPendingOperationsSimple": "Nenhuma operação pendente",
    "couldNotFindInsertPosition": "Não foi possível encontrar a posição de inserção",
    "noContentToInsert": "Nenhum conteúdo para inserir",
    "noReferenceText": "Nenhum texto de referência foi especificado",
    "completeDeletesBeforeInsert": "Conclua ou cancele as eliminações pendentes antes de fazer inserções",
    "completeUpdatesBeforeInsert": "Conclua ou cancele as atualizações pendentes antes de fazer inserções",
    "insertExtensionNotAvailable": "A extensão de inserção não está disponível",
    "couldNotGenerateReport": "Não foi possível gerar o relatório",
    "textInsertedInReport": "Texto inserido no relatório",
    "textInsertedInDescription": "Texto inserido na descrição",
    "textInsertedAtEndOfReport": "Texto inserido no final do relatório",
    "textUpdated": "Texto atualizado",
    "textDeleted": "Texto eliminado",
    "matchesFoundClickToUpdate": "{{count}} correspondências encontradas. Clique no texto sublinhado para atualizá-lo.",
    "matchesFoundUseSelect": "{{count}} correspondências encontradas. Use 'selecionar' para escolher quais eliminar.",
    "matchesDeleted": "{{count}} correspondência(s) eliminada(s)",
    "matchesUpdated": "{{count}} correspondência(s) atualizada(s)",
    "couldNotProcessDeletions": "Não foi possível processar as eliminações",
    "couldNotProcessUpdates": "Não foi possível processar as atualizações",
    "generateReportOnlyFromDescription": "O comando gerar relatório só funciona a partir da descrição ou com índices",
    "generatingReport": "Gerando relatório...",
    "voiceInputProcessingError": "Erro ao processar a entrada de voz",
    "deleteExtensionNotAvailable": "A extensão de eliminação não está disponível",
    "textNotFoundInValidSection": "\"{{text}}\" não encontrado numa seção válida",
    "textNotFoundForInsert": "\"{{text}}\" não encontrado para inserção",
    "noSectionSpecified": "Nenhuma seção foi especificada",
    "sectionNotFound": "Seção \"{{section}}\" não encontrada",
    "textNotFoundInSection": "\"{{text}}\" não encontrado na seção \"{{section}}\"",
    "sectionTitleRequired": "É necessário um título para a seção",
    "referenceSectionRequired": "É necessário especificar a seção de referência",
    "cannotAddSection": "Não é possível adicionar a seção",
    "couldNotInsertSection": "Não foi possível inserir a seção",
    "errorInsertingSection": "Erro ao inserir a seção",
    "couldNotDetermineInsertPosition": "Não foi possível determinar a posição de inserção em \"{{section}}\"",
    "errorInsertingTextInSection": "Erro ao inserir texto na seção",
    "noCommandRecognized": "Nenhum comando reconhecido"
  },
  "share": {
    "me": "Eu",
    "sharedWith": "Partilhado com",
    "title": "Compartilhar rascunho",
    "tabUsers": "Pessoas",
    "tabLink": "Link",
    "searchUser": "Pesquisar por nome ou email...",
    "userAdded": "Usuário adicionado com sucesso",
    "cannotShareSelf": "Você não pode compartilhar consigo mesmo",
    "differentAccount": "Você só pode compartilhar com usuários da sua conta",
    "errorSharing": "Erro ao compartilhar",
    "userRemoved": "Acesso revogado",
    "errorRemoving": "Erro ao revogar acesso",
    "errorUpdating": "Erro ao atualizar permissões",
    "linkEnabled": "Link ativado",
    "errorLink": "Erro ao atualizar link",
    "linkCopied": "Link copiado para a área de transferência",
    "errorCopyLink": "Erro ao copiar link",
    "tokenRegenerated": "Link regenerado",
    "errorRegenerate": "Erro ao regenerar link",
    "owner": "Proprietário",
    "addedBy": "Adicionado por",
    "permView": "Visualizar",
    "permEdit": "Editar",
    "targetNotFound": "Utilizador com quem pretende partilhar não encontrado",
    "linkInvalid": "Link inválido ou desativado",
    "linkOtherAccount": "Este link pertence a outra conta e não pode ser aberto",
    "joinError": "Erro ao aceder ao rascunho partilhado",
    "goToReports": "Ir para os relatórios",
    "joining": "A abrir o rascunho partilhado...",
    "noUsersFound": "Nenhum usuário encontrado",
    "noUsersShared": "Ainda não compartilhado com ninguém",
    "shareLinkTitle": "Compartilhar por link",
    "shareLinkDesc": "Qualquer um com o link pode acessar",
    "linkPermission": "Permissão do link",
    "removeAccess": "Revogar acesso",
    "addUser": "Compartilhar",
    "copy": "Copiar",
    "copyLink": "Copiar link",
    "errorUpdatingLink": "Erro ao atualizar o link"
  },
  "collaboration": {
    "connected": "Ao vivo",
    "connecting": "A ligar...",
    "invite": "Convidar",
    "inviteMore": "Convidar mais pessoas"
  },
  "workHistory": {
    "title": "Histórico de trabalho",
    "subtitle": "Histórico de trabalho",
    "sent": "Enviados",
    "drafts": "Rascunhos",
    "empty": "Não há relatórios nesta seção.",
    "error": "Não foi possível carregar o histórico."
  },
  "groupReports": {
    "exportFileName": "historico_trabalho",
    "titlePrefix": "Histórico de ",
    "titleAccent": "trabalho",
    "subtitle": "Relatórios enviados e rascunhos dos membros do grupo.",
    "subtitleAccount": "Relatórios enviados e rascunhos dos membros da conta.",
    "subtitleSelf": "Os seus relatórios enviados e rascunhos.",
    "kind": "Tipo de relatório",
    "sent": "Enviados",
    "drafts": "Rascunhos",
    "author": "Autor",
    "allAuthors": "Todo o grupo",
    "scope": "Âmbito",
    "scopeAccount": "Toda a conta",
    "scopeSearch": "Pesquisar grupo ou pessoa…",
    "scopeExpand": "Ver membros do grupo",
    "scopeNoMatches": "Sem correspondências.",
    "scopeEmptyGroup": "Grupo sem utilizadores.",
    "search": "Pesquisar",
    "searchPlaceholder": "Pesquisar por título…",
    "from": "De",
    "to": "Até",
    "clearFilters": "Limpar filtros",
    "count": "{{count}} resultados",
    "searchModality": "Modalidade…",
    "searchRegion": "Região…",
    "modalities": "Modalidades",
    "regions": "Regiões",
    "allTags": "Ver todas as etiquetas",
    "exportReports": "Descarregar relatórios",
    "exportPreviewTitle": "Descarregar relatórios",
    "exportPreviewSubtitle": "Pré-visualização do ficheiro Excel que será descarregado.",
    "exportSheetName": "historico_trabalho",
    "exportRowCount": "{{count}} linhas",
    "exportMoreRows": "+ {{count}} linhas na exportação",
    "exportCol_title": "Título",
    "exportCol_author": "Autor",
    "exportCol_group": "Grupo",
    "exportCol_date": "Data",
    "exportCol_modality": "Modalidade",
    "exportCol_region": "Região",
    "exportDownload": "Descarregar Excel",
    "exportError": "Não foi possível carregar os relatórios para exportar.",
    "exportErrorDownload": "Não foi possível gerar o ficheiro Excel.",
    "processingLabel": "{{count}} relatório(s) em processamento",
    "processingTooltip": "{{count}} relatório(s) em processamento. A lista será atualizada automaticamente ao terminar.",
    "untitled": "Sem título",
    "noMatches": "Nenhum relatório corresponde aos filtros.",
    "empty": "Ainda não há relatórios no seu grupo.",
    "emptySelf": "Ainda não tem relatórios.",
    "error": "Não foi possível carregar os relatórios do grupo.",
    "errorSelf": "Não foi possível carregar os seus relatórios."
  },
  "radiologistInsights": {
    "periodCustom": "Período personalizado",
    "title": "Suas métricas",
    "subtitle": "Atividade de {{name}}",
    "groupFallbackName": "grupo",
    "scopeLabel": "Âmbito das estatísticas",
    "scopePersonal": "Área pessoal",
    "scopeGroup": "Área do grupo",
    "groupPlaceholderTitle": "Estatísticas do grupo",
    "groupPlaceholderText": "As estatísticas agregadas do grupo estarão disponíveis em breve.",
    "correlationTitle": "Atividade conjunta dos radiologistas",
    "correlationSubtitle": "Atividade conjunta em relação ao radiologista com mais laudos do grupo (0–1)",
    "correlationPairCount": "{{count}} comparações",
    "correlationPairOne": "1 comparação",
    "correlationNoPairs": "São necessários pelo menos dois radiologistas para comparar a atividade.",
    "correlationError": "Não foi possível carregar os radiologistas do grupo.",
    "correlationEmpty": "Não há radiologistas no grupo.",
    "groupError": "Não foi possível carregar as estatísticas do grupo.",
    "groupOverviewSection": "Visão do grupo",
    "groupRadiologistsSection": "Radiologistas",
    "groupProductionTitle": "Produção do grupo",
    "groupProductionSubtitle": "{{total}} laudos no período selecionado",
    "groupModalityTitle": "Laudos por modalidade",
    "groupModalitySubtitle": "Distribuição do grupo",
    "topRadiologistsTitle": "Radiologistas mais produtivos",
    "topRadiologistsSubtitle": "Laudos realizados por radiologista",
    "timePerRadiologistTitle": "Tempo médio por radiologista",
    "timePerRadiologistSubtitle": "Minutos de edição por laudo",
    "snomedTooltip": "Todos os achados são padronizados usando o código internacional SNOMED CT",
    "processingLabel": "{{count}} laudo(s) em processamento",
    "processingTooltip": "Há {{count}} laudo(s) em processamento. Os gráficos serão atualizados automaticamente quando terminar.",
    "periodMonth": "Este mês",
    "periodWeek": "Última semana",
    "periodLast30": "Últimos 30 dias",
    "periodDay": "Hoje",
    "kpi": {
      "reportsMonth": "Relatórios este mês",
      "reportsRange": "Relatórios do período",
      "vsPrevRange": "vs período anterior",
      "reportsWeek": "Relatórios esta semana",
      "reportsDay": "Relatórios hoje",
      "reportsLast30": "Relatórios últimos 30d",
      "vsLastMonth": "vs mês anterior",
      "vsLastWeek": "vs semana anterior",
      "vsYesterday": "vs ontem",
      "vsPrev30": "vs 30 dias anteriores",
      "topModality": "Sua modalidade principal",
      "topRegion": "Sua região principal",
      "reportsCount": "{{count}} relatórios",
      "percentOfTotal": "{{percent}}% do total",
      "findingsPerReport": "Achados por relatório",
      "billing": "Faturamento",
      "accumulated": "Acumulado do mês",
      "topRadiologist": "Radiologista com mais laudos",
      "groupTotalReports": "Laudos do grupo",
      "thisMonth": "este mês",
      "activeRadiologists": "Radiologistas ativos",
      "inTheGroup": "no grupo",
      "groupAvgEditTime": "Tempo médio de edição",
      "perReport": "por laudo"
    },
    "reportsPerDay": "Relatórios por dia",
    "dailyAverage": "Sua média diária: {{average}} relatórios",
    "reports": "relatórios",
    "dayLabel": "Dia {{day}}",
    "today": "hoje",
    "average": "média",
    "modalities": "Suas modalidades",
    "periodDistribution": "Distribuição do período",
    "noData": "Sem dados",
    "frequentFindings": "Achados mais frequentes",
    "seeAll": "Ver todos →",
    "inYourReports": "Nos seus relatórios · {{total}} menções totais",
    "findingsBy": "Achados por",
    "searchModality": "Pesquisar modalidade...",
    "searchRegion": "Pesquisar região...",
    "noFindingsForFilters": "Não há achados para estes filtros no período.",
    "filter": "Filtrar:",
    "yourReportsCount": "{{count}} relatórios seus",
    "billing": "Seu faturamento",
    "billingMeta": "{{range}} · <strong>{{accumulated}}</strong> acumulado · projeção fim do mês {{projection}}",
    "billingMetaWeek": "{{range}} · <strong>{{accumulated}}</strong> acumulado · projeção fim de semana {{projection}}",
    "billingMetaDay": "{{range}} · <strong>{{accumulated}}</strong> acumulado hoje",
    "billingMetaLast30": "{{range}} · <strong>{{accumulated}}</strong> acumulado nos últimos 30 dias",
    "billingCumulative": "Acumulado",
    "billingDaily": "Receita diária",
    "billingDailySubtitle": "O que você faturou em cada dia do período",
    "editTimeSection": "Tempo de edição",
    "reportsSection": "Relatórios",
    "findingsSection": "Achados",
    "billingSection": "Faturamento",
    "editTimeAvgCard": "Tempo médio por relatório",
    "editTimeCardSub": "{{reports}} relatórios · {{total}} total",
    "editTimeEmpty": "Sem dados de edição neste período",
    "editTimeMedianCard": "Mediana por relatório",
    "editTimeMedianSub": "Valor central de {{reports}} relatórios",
    "editTimeLastCard": "Último relatório",
    "editTimeLastSub": "Tempo do relatório mais recente",
    "editTime": "Tempo dedicado ao dia",
    "editTimeAvg": "Média por relatório: {{average}} · Total: {{total}} em {{reports}} relatórios",
    "editTimeLabel": "tempo",
    "presave": {
      "sectionTitle": "Inconsistências e avisos",
      "overrideRate": "Taxa de envios forçados",
      "overrideTrendTooltip": "Variação em relação ao período anterior (pontos percentuais)",
      "overrideSub": "{{count}} decisões",
      "totalWarnings": "Avisos do grupo",
      "totalSub": "{{forced}} enviados mesmo assim",
      "warningsPerReport": "Inconsistências por relatório",
      "perReport": "densidade",
      "topOverride": "Maior taxa de envios forçados",
      "topOverrideSub": "{{pct}} % · {{forced}} enviados mesmo assim",
      "timelineTitle": "Inconsistências por dia",
      "timelineSubtitle": "Distribuição diária entre Revisar (verde) e Enviar mesmo assim (vermelho)",
      "splitTitle": "Distribuição das decisões",
      "splitSubtitle": "Fração de envios forçados sobre o total decidido",
      "radiologistsTitle": "Taxa de inconsistências não resolvidas por radiologista",
      "radiologistsSubtitle": "% de avisos enviados mesmo assim sobre o total decidido",
      "radiologistsVolumeTitle": "Radiologistas com mais inconsistências",
      "radiologistsVolumeSubtitle": "Total de avisos emitidos por cada radiologista do grupo",
      "templatesTitle": "Modelos com mais avisos",
      "templatesSubtitle": "Procedimentos onde se origina a inconsistência",
      "listTitle": "Eventos de inconsistências",
      "listMeta": "{{total}} avisos",
      "colDate": "Data",
      "colRadiologist": "Radiologista",
      "colJustification": "Justificação",
      "colDecision": "Decisão",
      "review": "Revisar",
      "forceSend": "Enviar mesmo assim",
      "pending": "Pendente",
      "override": "Forçados",
      "empty": "Sem avisos no período selecionado.",
      "loadMore": "Carregar mais ({{remaining}} restantes)",
      "collapse": "Recolher"
    }
  },
  "voice": {
    "recoveryTitle": "Gravação não processada",
    "recoveryDescription": "Não foi possível processar a gravação após várias tentativas. Pode tentar novamente ou descartar a gravação.",
    "recoveryRetry": "Tentar novamente",
    "recoveryDownload": "Baixar áudio",
    "recoveryDiscard": "Descartar",
    "recoveryConfirmDiscard": "Tem certeza? Clique novamente",
    "hardLimitReached": "Limite máximo de gravação atingido (1h 30m). O áudio está sendo processado.",
    "importBusy": "Conclua ou cancele o ditado em curso antes de importar um áudio.",
    "importMultipleFiles": "Solte um único arquivo de áudio.",
    "importUnsupportedType": "Apenas arquivos de áudio são aceitos.",
    "importTooLarge": "O arquivo excede o limite de {{maxMb}} MB.",
    "importTooLong": "O áudio excede o limite de {{maxMin}} minutos.",
    "importDecodeFailed": "Não foi possível ler o áudio. Tente outro formato.",
    "importNoVoice": "Nenhuma voz detectada no áudio importado.",
    "importNoEncoder": "Este navegador não consegue preparar áudio importado. Atualize-o ou use outro navegador.",
    "importError": "Não foi possível preparar o áudio importado.",
    "importComposeFailed": "Não foi possível unir o áudio. O ditado continua em pausa: envie-o novamente.",
    "importPreparing": "A preparar o áudio…",
    "importDropHint": "Largue o áudio para o carregar",
    "softLimitWarning": "A gravação já dura mais de 10 minutos",
    "errorTimeout": "O servidor demorou demais. Seu áudio está salvo, pode tentar novamente.",
    "errorDisconnected": "A conexão com o servidor foi perdida. Seu áudio está salvo.",
    "generationInProgress": "Já existe uma geração em andamento. Aguarde a conclusão.",
    "errorAfterApplied": "A geração terminou com um erro. Revise o conteúdo aplicado ao laudo.",
    "errorGeneration": "Erro ao gerar o relatório. Seu áudio está salvo, pode tentar novamente.",
    "errorGeneric": "Erro ao processar o áudio. Seu áudio está salvo.",
    "audioSaved": "Áudio recebido",
    "templateNotFound": "Modelo \"{{templateName}}\" não encontrado.",
    "processingDictation": "Processando ditado…",
    "holdCancel": "Cancelar",
    "holdLock": "Bloquear",
    "holdSend": "Enviar",
    "traditionalDictation": "Ditado tradicional",
    "holdRightClickHint": "Mantenha para ditar"
  },
  "micPage": {
    "title": "Microfone do telemóvel",
    "connecting": "A ligar…",
    "needPermission": "Tens de aceitar a permissão do microfone no telemóvel antes de gravar. Toca para permitir.",
    "allowMic": "Permitir microfone",
    "retryMic": "Tentar novamente a permissão do microfone",
    "permissionBlocked": "O acesso ao microfone foi recusado. Ativa-o nas definições do navegador do telemóvel e toca outra vez.",
    "micNotFound": "Não foi detetado nenhum microfone neste telemóvel.",
    "micBusy": "Outra aplicação está a usar o microfone. Fecha-a e tenta novamente.",
    "micUnavailable": "Não foi possível aceder ao microfone do telemóvel. Toca outra vez para tentar.",
    "ready": "Pronto. Toca no botão para gravar.",
    "waitingDesktop": "À espera do computador…",
    "recording": "A gravar…",
    "paused": "Em pausa",
    "processing": "A processar áudio…",
    "processingHint": "O Silero está a cortar silêncios…",
    "record": "Gravar",
    "pause": "Pausa",
    "resume": "Retomar",
    "stop": "Enviar",
    "cancel": "Cancelar",
    "desktopConnected": "Computador ligado",
    "desktopWaiting": "Computador não ligado",
    "desktopBusy": "O computador está a gravar. Aguarda que termine.",
    "missingToken": "Falta o link de emparelhamento. Leia o QR outra vez.",
    "invalidToken": "O link não é válido. Gere outro código no computador.",
    "expiredToken": "O código expirou. Gere outro no computador.",
    "roomFull": "Já há um telemóvel ligado a este código.",
    "permissionDenied": "Não foi possível aceder ao microfone. Verifique a permissão do browser.",
    "insecureOrigin": "O microfone precisa de HTTPS (ou localhost).",
    "disconnected": "Perdeu-se a ligação com o computador.",
    "helloTimeout": "Não foi possível entrar na sala. Tente novamente.",
    "idle": "A sala fechou por inatividade.",
    "recordingLimit": "Foi atingido o limite de gravação.",
    "relayError": "Não foi possível ligar. Gere outro código no computador."
  },
  "orgAdmin": {
    "backToApp": "Voltar ao Ainovis",
    "loadError": "Não foi possível carregar as informações.",
    "saveError": "Não foi possível guardar. Verifique os dados e tente novamente.",
    "comingSoon": "Em breve",
    "shell": {
      "eyebrow": "Administração",
      "pageTitlePrefix": "Painel de ",
      "pageTitleAccent": "administração",
      "pageSubtitle": "Administra toda a conta {{name}}",
      "meta": "{{groups}} grupos · {{users}} utilizadores"
    },
    "rail": {
      "title": "Conta",
      "groups": "Grupos",
      "account": "Toda a conta",
      "accountPicker": "Conta",
      "emptyAccount": "Ainda não há grupos. Adicionar o primeiro",
      "usersTooltip": "Utilizadores do grupo"
    },
    "confirm": {
      "deleteGroupHint": "Os seus utilizadores ficam sem grupo atribuído. Não é possível anular.",
      "irreversible": "Esta ação não pode ser anulada."
    },
    "nav": {
      "overview": "Resumo",
      "stats": "Estatísticas",
      "groups": "Grupos",
      "users": "Utilizadores",
      "templates": "Modelos",
      "settings": "Permissões"
    },
    "period": {
      "month": "Mês",
      "week": "Semana",
      "day": "Dia",
      "last30": "Últimos 30 dias"
    },
    "overview": {
      "title": "Resumo",
      "subtitle": "Atividade de {{name}}",
      "reports": "Relatórios",
      "activeUsers": "Utilizadores ativos",
      "avgEdit": "Edição média",
      "topUser": "Utilizador em destaque",
      "reportsCount": "{{count}} relatórios",
      "activity": "Atividade",
      "contact": "Dados de contacto",
      "noContact": "Sem dados de contacto.",
      "parent": "Conta",
      "shortcuts": "Ir para",
      "groupsTitle": "Grupos",
      "topGroup": "Grupo com mais relatórios",
      "fastestGroup": "Grupo mais rápido"
    },
    "groups": {
      "title": "Grupos",
      "subtitle": "Grupos da conta",
      "addGroup": "Adicionar grupo",
      "emptyGroups": "Esta conta ainda não tem grupos.",
      "usersCount": "{{active}}/{{count}} utilizadores",
      "deleteGroupConfirm": "Eliminar o grupo {{name}}?",
      "editGroup": "Editar grupo"
    },
    "form": {
      "name": "Nome",
      "surname": "Apelidos",
      "nationalId": "NIF",
      "nameRequired": "O nome é obrigatório.",
      "address": "Morada",
      "professionalTitle": "Título profissional (opcional)",
      "email": "Email",
      "phone": "Telefone",
      "namePlaceholder": "Ex: Maria",
      "surnamePlaceholder": "Ex: Silva Santos",
      "emailPlaceholder": "Ex: maria@hospital.com",
      "nationalIdPlaceholder": "Ex: 12345678A",
      "addressPlaceholder": "Ex: Rua Principal 1, Lisboa",
      "professionalTitlePlaceholder": "Dr., Dra., ...",
      "phonePlaceholder": "Ex: +351 210 123 456"
    },
    "users": {
      "title": "Utilizadores",
      "searchPlaceholder": "Procurar por nome ou email",
      "allRoles": "Todos os papéis",
      "allStatuses": "Todos os estados",
      "filters": "Filtros",
      "columnUser": "Utilizador",
      "columnRole": "Papel",
      "columnGroup": "Grupo",
      "columnStatus": "Estado",
      "statusActive": "Ativo",
      "statusPending": "Pendente",
      "statusInactive": "Inativo",
      "noGroup": "Sem grupo",
      "count": "{{count}} utilizadores",
      "empty": "Esta conta ainda não tem utilizadores.",
      "emptyFiltered": "Nenhum utilizador corresponde aos filtros.",
      "selected": "{{count}} selecionados",
      "selectAll": "Selecionar todos",
      "bulkLabel": "Modelos pessoais:",
      "bulkDone": "{{count}} utilizadores atualizados.",
      "bulkPartial": "Não foi possível atualizar {{count}} utilizadores.",
      "columnActions": "Ações",
      "add": "Adicionar utilizador",
      "addHint": "Vai receber um email para verificar a conta e definir a palavra-passe.",
      "sendInvite": "Criar e convidar",
      "createOnly": "Criar sem convidar",
      "edit": "Editar utilizador",
      "editHint": "O papel e o grupo alteram-se a partir da tabela.",
      "emailLocked": "O email de acesso não pode ser alterado.",
      "updated": "Utilizador atualizado.",
      "formRequired": "Preencha todos os campos obrigatórios.",
      "resend": "Reenviar convite",
      "activate": "Ativar",
      "deactivate": "Desativar",
      "activated": "Utilizador ativado.",
      "deactivated": "Utilizador desativado.",
      "roleChanged": "Papel atualizado.",
      "groupChanged": "Utilizador mudado de grupo.",
      "inviteSent": "Convite enviado.",
      "deleted": "Utilizador eliminado.",
      "deleteTitle": "Eliminar {{name}}?",
      "deleteHint": "Também se apagam os seus rascunhos, modelos e definições.",
      "loadMore": "Carregar mais ({{remaining}} restantes)",
      "endOfList": "Não há mais utilizadores.",
      "page": "Página {{page}} de {{totalPages}}",
      "loadError": "Não foi possível carregar os utilizadores.",
      "accessTitle": "Acesso e permissões",
      "accessSelfHint": "Não pode alterar o seu próprio perfil nem as suas permissões."
    },
    "templates": {
      "title": "Modelos",
      "total": "{{count}} modelos",
      "upload": "Carregar",
      "uploadScope": "Âmbito",
      "uploadScopePlaceholder": "Escolhe um âmbito…",
      "scopeEverything": "Conta e grupos",
      "scopeAll": "{{name}}",
      "scopeOnlyAccount": "Apenas a conta",
      "hintAll": "{{total}} modelos em {{count}} grupos",
      "hintAccount": "Visível para os {{count}} grupos da conta {{name}} · {{total}} modelos",
      "hintGroup": "Visível apenas para a equipa de {{name}} · {{total}} modelos",
      "searchPlaceholder": "Procurar modelo",
      "selected": "{{count}} selecionados",
      "moveTo": "Mover para",
      "edit": "Editar modelo",
      "select": "Selecionar {{name}}",
      "page": "Página {{page}} de {{totalPages}}",
      "emptyAccount": "Esta conta ainda não tem modelos institucionais.",
      "emptyGroup": "Este grupo não tem modelos próprios.",
      "emptyGroupHint": "Também vê os {{count}} da conta {{name}}.",
      "emptyFiltered": "Nenhum modelo corresponde à procura.",
      "confirmDelete": "Eliminar {{count}} modelos? Não é possível anular.",
      "confirmPromote": "Vais tornar {{count}} modelos visíveis para os {{groups}} grupos da conta {{name}}.",
      "loadError": "Não foi possível carregar os modelos.",
      "moveError": "Não foi possível mover os modelos.",
      "languageError": "Não foi possível alterar o idioma do modelo.",
      "deleteError": "Não foi possível eliminar os modelos.",
      "processing": "A guardar",
      "processingHint": "Este modelo já foi guardado. Ainda está a ser preparado para o ditado e não poderá ser detetado automaticamente até estar pronto."
    },
    "scope": {
      "account": "Toda a conta",
      "group": "Grupo"
    },
    "settings": {
      "title": "Definições",
      "applyNote": "Substitui a política dos {{count}} grupos existentes pelos valores acima."
    },
    "policy": {
      "title": "Política de modelos",
      "groupNote": "Aplica-se aos utilizadores deste grupo sem permissões personalizadas.",
      "personalTitle": "Modelos pessoais",
      "personalHint": "Permite que os radiologistas usem, criem e editem os seus próprios modelos e blocos. Ao desativar, deixam de ver também os que já tinham.",
      "ainovisTitle": "Modelos Ainovis",
      "ainovisHint": "Permite aceder aos modelos Ainovis. Se desativado, deixam de estar disponíveis na aplicação.",
      "institutionalTitle": "Modelos institucionais",
      "institutionalHint": "Permite aceder aos modelos do grupo e da conta. Se desativado, deixam de estar disponíveis na aplicação.",
      "allowed": "Permitido",
      "blocked": "Bloqueado",
      "inherit": "Herdado do grupo ({{state}})",
      "inheritShort": "Herdado do grupo",
      "groupPolicy": "Herdado do grupo",
      "legend": "Permitido / Bloqueado / Herdado do grupo: o que significa cada valor.",
      "legendAllowed": "esta pessoa pode sempre usá-lo, mesmo que o seu grupo o proíba.",
      "legendBlocked": "esta pessoa nunca pode usá-lo, mesmo que o seu grupo o permita.",
      "legendGroup": "esta pessoa não tem definição própria; aplica-se a decisão do seu grupo (mostrada ao lado).",
      "legendNoGroup": "esta pessoa não tem grupo atribuído; aplica-se a política predefinida da conta.",
      "alwaysAllowed": "Sempre permitido",
      "exemptHint": "Os administradores podem sempre criar modelos.",
      "saved": "Política atualizada.",
      "defaultsTitle": "Permissões de modelos",
      "defaultsWarning": "Estas permissões aplicam-se aos novos grupos. Os grupos existentes não são alterados.",
      "applyToGroups": "Aplicar permissões a grupos existentes",
      "applyConfirm": "A política de todos os grupos da conta será substituída. Continuar?",
      "applied": "Aplicado a {{count}} grupos."
    },
    "classifications": {
      "title": "Política de classificações",
      "note": "Define quem pode usar as classificações nesta conta e que escalas estão disponíveis.",
      "groupNote": "O que se aplica aos utilizadores deste grupo, salvo permissão própria.",
      "defaultsWarning": "Valores iniciais dos novos grupos. Os grupos existentes mantêm os seus.",
      "userTitle": "Classificações",
      "userHint": "Permite a esta pessoa usar as classificações, independentemente do seu grupo.",
      "scalesTitle": "Classificações disponíveis",
      "scalesCount": "{{active}} de {{total}} ativas",
      "scalesUserTitle": "Escolher uma a uma",
      "scalesUserHint": "Exceções para esta pessoa; o que não for alterado segue o grupo.",
      "audienceTitle": "Quem pode classificar",
      "saved": "Política de classificações atualizada.",
      "audience": {
        "nobody": "Ninguém",
        "admins": "Apenas administradores",
        "everyone": "Toda a conta"
      },
      "audienceDesc": {
        "nobody": "Ninguém na conta pode classificar.",
        "admins": "Comportamento atual: apenas os administradores podem classificar.",
        "everyone": "Qualquer utilizador da conta pode classificar."
      },
      "hints": {
        "FLEISCHNER": "Nódulo pulmonar",
        "TI-RADS": "Tiroide",
        "PI-RADS": "Próstata",
        "BOSNIAK_2019": "Quisto renal",
        "GARDEN": "Fratura da anca",
        "EATON_LITTLER": "Rizartrose (mão)",
        "SNYDER": "Coifa dos rotadores (ombro)",
        "HERBERT_FISCHER": "Fratura do escafoide (punho)"
      }
    },
    "permissions": {
      "column": "Permissões",
      "edit": "Editar permissões",
      "title": "Permissões de {{name}}",
      "bulkTitle": "Permissões de {{count}} utilizadores",
      "bulkHint": "As alterações aplicam-se a todos os utilizadores selecionados.",
      "inherited": "Herdadas",
      "custom": "Personalizadas",
      "mixed": "Vários valores",
      "partialExempt": "{{count}} dos utilizadores selecionados têm-no sempre permitido."
    },
    "group": {
      "back": "Voltar aos grupos",
      "title": "Grupo",
      "subtitle": "Atividade e equipa do grupo",
      "team": "Equipa",
      "emptyTeam": "Este grupo ainda não tem utilizadores.",
      "active": "Ativo",
      "inactive": "Inativo"
    },
    "roles": {
      "user": "Utilizador",
      "admin": "Admin",
      "supervisor": "Supervisor",
      "super": "Super"
    }
  }
}
